<!-- 首页弹窗 -->
<template>
  <div class="Map" @mouseover="mouseoverMap" @mouseout="mouseoutMap">
    <baidu-map
      class="map"
      :center="center"
      :zoom="zoom"
      @ready="handler"
      :mapStyle="mapStyle"
      @click="getClickInfo"
      :scroll-wheel-zoom="true"
    >
      <div v-for="(item, i) in siteVos" :key="i">
        <!-- 在线 -->
        <template v-if="showSiteVos">
          <bm-marker
            v-if="
              item.deviceStatus == '0' &&
              item.waterLevelAlarmStatus == '0'&&item.accessControlStatus=='0'&&item.perimeterStatus=='0'
            "
            :position="{ lng: item.lng, lat: item.lat }"
            :icon="{
              url: require('@/assets/images/bz/zaixian.png'),
              size: { width: 35, height: 41 },
            }"
            :zIndex="9"
            @mouseover="openInfoBox(item.lng, item.lat, item.id)"
            @mouseout="closeInfoBox"
            @click="goPush(item.id)"
          >
          </bm-marker>

          <!-- 报警 -->
          <bm-marker
            v-if="
              item.deviceStatus == '0' &&
              (item.waterLevelAlarmStatus == '1'||item.accessControlStatus=='1'||item.perimeterStatus=='1')
            "
            :position="{ lng: item.lng, lat: item.lat }"
            :icon="{
              url: require('@/assets/images/bz/baojing.png'),
              size: { width: 35, height: 41 },
            }"
            :zIndex="9"
            @mouseover="openInfoBox(item.lng, item.lat, item.id)"
            @mouseout="closeInfoBox"
            @click="goPush(item.id)"
          >
          </bm-marker>
          <!-- 离线 -->
          <bm-marker
            v-if="item.deviceStatus == '1'"
            :position="{ lng: item.lng, lat: item.lat }"
            :icon="{
              url: require('@/assets/images/bz/lixian.png'),
              size: { width: 35, height: 41 },
            }"
            :zIndex="9"
            @mouseover="openInfoBox(item.lng, item.lat, item.id)"
            @mouseout="closeInfoBox"
            @click="goPush(item.id)"
          >
          </bm-marker>
        </template>
      </div>

      <!-- 渠道流量计  -->
      <div
        v-for="(item, index) in ditchFlowMeters"
        :key="'ditchFlowMeters' + index"
      >
        <template v-if="showFlowMeters">
          <bm-marker
            :position="{ lng: item.lng, lat: item.lat }"
            :icon="{
              url: require('@/assets/images/bz/llj.png'),
              size: { width: 32, height: 37 },
            }"
            :zIndex="9"
            @mouseover="openDitchFlowMeterBox(item.lng, item.lat, item.meterId)"
            @mouseout="closeDitchFlowMeterBox"
          >
          </bm-marker>
        </template>
      </div>

      <!-- 流量计  -->
      <div v-for="(item, index) in flowMeters" :key="'flowMeters' + index">
        <template v-if="showFlowMeters">
          <bm-marker
            :position="{ lng: item.lng, lat: item.lat }"
            :icon="{
              url: require('@/assets/images/bz/llj.png'),
              size: { width: 32, height: 37 },
            }"
            :zIndex="9"
            @mouseover="openFlowMeterBox(item.lng, item.lat, item.devSn)"
            @mouseout="closeFlowMeterBox"
          >
          </bm-marker>
        </template>
      </div>

      <!-- 泵站  -->
      <div v-for="(item, index) in pumpStations" :key="'pumpStations' + index">
        <template v-if="showPumpStations">
          <bm-marker
            :position="{ lng: item.lng, lat: item.lat }"
            :icon="{
              url: require('@/assets/images/bz/bz.png'),
              size: { width: 31, height: 35 },
            }"
            :zIndex="9"
            @mouseover="openPumpMeterBox(item.lng, item.lat, item.id)"
            @mouseout="closePumpBox"
            @click="toPumpStationPush(item.id, item.staId)"
          >
          </bm-marker>
        </template>
      </div>
    </baidu-map>
    <!-- 状态 -->
    <div class="map-data-tip" ref="mapData">
      <div class="typeOne">
        <span>状态:</span>
      </div>
      <div class="typeTwo">
        <div class="tip-type">
          <span>正常</span>
          <span class="green"></span>
        </div>
        <div class="tip-type">
          <span>离线</span>
          <span class="gray"></span>
        </div>
        <div class="tip-type">
          <span>报警</span>
          <span class="red"></span>
        </div>
      </div>
    </div>
    <div class="map-checkbox">
      <el-radio-group
        v-model="checkboxGroup2"
        @change="handleCheckedCitiesChange"
      >
        <el-radio-button v-for="city in cities" :label="city" :key="city"
          >{{ city }}
        </el-radio-button>
      </el-radio-group>
    </div>
    <div class="icoQuan">
      <!--      <div><img src="@/assets/images/ico/icolj.png" alt=""></div>-->
      <div><img src="@/assets/images/ico/icozai.png" alt="" /></div>
      <div>
        <img
          style="position: relative; left: -28px"
          src="@/assets/images/ico/icollj.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
const cityOptions = ["全选", "节制闸", "测流点"];
import {
  getAllSiteList,
  getSiteByIdList,
  getRainById,
  getDitchFlowMeter,
  getFlowMeter,
  getPumpStation,
} from "../../../../api/index";
import { llj, qdllj, bz } from "@/assets/js/html";
import { login } from "../../../../api/login";

export default {
  props: {
    siteId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      infoBox: null,
      lastInfoBox: null,
      checkboxGroup2: "全选",
      checkAll: true,
      isIndeterminate: true,
      cities: cityOptions,
      showPumpStations: true,
      showFlowMeters: true,
      showDitchFlowMeters: true,
      showSiteVos: true,
      isMains: "", // 市电或者太阳能
      siteItemVo: {}, // 获取到的站点信息
      alarmStatus: "", // 获取到的预警状态
      gateVo: {}, // 闸门信息
      siteVos: [], // 站点列表
      rainVos: [], // 雨情列表
      ditchFlowMeters: [], // 渠道流量计
      ditchFlowMeterCount: "",
      flowMeters: [], // 流量计
      flowMeterCount: "",
      pumpStations: [], // 泵站
      pumpStationCount: "",
      center: {
        lng: 114.90745,
        lat: 34.848941,
      },
      zoom: 12,
      // 顺序 雨情 站点 正常 掉线 报警
      normalRainCount: "",
      normalSiteCount: "",
      offlineRainCount: "",
      offlineSiteCount: "",
      warningRainCount: "",
      warningSiteCount: "",
      rainfallTime: "", // 降雨时长
      rainfall: "", // 降雨量
      DongyingData: {},
      mapStyle: {
        styleJson: [
          {
            featureType: "land",
            elementType: "geometry",
            stylers: {
              color: "#f5f6f7ff",
            },
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: {
              color: "#26b6f0ff",
            },
          },
          {
            featureType: "green",
            elementType: "geometry",
            stylers: {
              color: "#dcf2d5ff",
            },
          },
          {
            featureType: "highway",
            elementType: "geometry.fill",
            stylers: {
              color: "#ffe59eff",
            },
          },
          {
            featureType: "highway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#f5d48cff",
            },
          },
          {
            featureType: "nationalway",
            elementType: "geometry.fill",
            stylers: {
              color: "#fff6ccff",
            },
          },
          {
            featureType: "provincialway",
            elementType: "geometry.fill",
            stylers: {
              color: "#fff6ccff",
            },
          },
          {
            featureType: "cityhighway",
            elementType: "geometry.fill",
            stylers: {
              color: "#fff6ccff",
            },
          },
          {
            featureType: "arterial",
            elementType: "geometry.fill",
            stylers: {
              color: "#fff6ccff",
            },
          },
          {
            featureType: "nationalway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#f2dc9dff",
            },
          },
          {
            featureType: "provincialway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#f2dc9dff",
            },
          },
          {
            featureType: "cityhighway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#f2dc9dff",
            },
          },
          {
            featureType: "arterial",
            elementType: "geometry.stroke",
            stylers: {
              color: "#f2dc9dff",
            },
          },
          {
            featureType: "building",
            elementType: "geometry.sidefill",
            stylers: {
              color: "#e6ebf0ff",
            },
          },
          {
            featureType: "building",
            elementType: "geometry.topfill",
            stylers: {
              color: "#e6ebf0ff",
            },
          },
          {
            featureType: "building",
            elementType: "geometry.stroke",
            stylers: {
              color: "#d8e2ebff",
            },
          },
          {
            featureType: "tertiaryway",
            elementType: "geometry.fill",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "tertiaryway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#dfe4ebff",
            },
          },
          {
            featureType: "fourlevelway",
            elementType: "geometry.fill",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "fourlevelway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#dfe4ebff",
            },
          },
          {
            featureType: "local",
            elementType: "geometry.fill",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "local",
            elementType: "geometry.stroke",
            stylers: {
              color: "#dfe4ebff",
            },
          },
          {
            featureType: "scenicspotsway",
            elementType: "geometry.fill",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "scenicspotsway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#dfe4ebff",
            },
          },
          {
            featureType: "universityway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#dfe4ebff",
            },
          },
          {
            featureType: "universityway",
            elementType: "geometry.fill",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "vacationway",
            elementType: "geometry.stroke",
            stylers: {
              color: "#dfe4ebff",
            },
          },
          {
            featureType: "vacationway",
            elementType: "geometry.fill",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "town",
            elementType: "labels.text",
            stylers: {
              fontsize: 18,
            },
          },
          {
            featureType: "town",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "town",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "highway",
            elementType: "labels.text.fill",
            stylers: {
              color: "#c0792dff",
            },
          },
          {
            featureType: "highway",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "nationalway",
            elementType: "labels.text.fill",
            stylers: {
              color: "#c0792dff",
            },
          },
          {
            featureType: "nationalway",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff60",
            },
          },
          {
            featureType: "provincialway",
            elementType: "labels.text.fill",
            stylers: {
              color: "#c0792dff",
            },
          },
          {
            featureType: "provincialway",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "cityhighway",
            elementType: "labels.text.fill",
            stylers: {
              color: "#c0792dff",
            },
          },
          {
            featureType: "cityhighway",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "arterial",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "arterial",
            elementType: "labels.text.fill",
            stylers: {
              color: "#c0792dff",
            },
          },
          {
            featureType: "arterial",
            elementType: "labels.text",
            stylers: {
              fontsize: 24,
            },
          },
          {
            featureType: "cityhighway",
            elementType: "labels.text",
            stylers: {
              fontsize: 24,
            },
          },
          {
            featureType: "provincialway",
            elementType: "labels.text",
            stylers: {
              fontsize: 24,
            },
          },
          {
            featureType: "nationalway",
            elementType: "labels.text",
            stylers: {
              fontsize: 24,
            },
          },
          {
            featureType: "highway",
            elementType: "labels.text",
            stylers: {
              fontsize: 24,
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "on",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "on",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "companylabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "companylabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "companylabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "on",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "on",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "lifeservicelabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "lifeservicelabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "lifeservicelabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "carservicelabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "carservicelabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "carservicelabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "transportationlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "on",
            },
          },
          {
            featureType: "transportationlabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "transportationlabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "financelabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "financelabel",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "financelabel",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "tertiaryway",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "tertiaryway",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "tertiaryway",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "fourlevelway",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "fourlevelway",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "fourlevelway",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "local",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "local",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "local",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "companylabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "lifeservicelabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "carservicelabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "financelabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels",
            stylers: {
              visibility: "on",
            },
          },
          {
            featureType: "manmade",
            elementType: "geometry",
            stylers: {
              color: "#f5f6f7ff",
            },
          },
          {
            featureType: "subway",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,13",
              level: "12",
            },
          },
          {
            featureType: "subway",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,13",
              level: "13",
            },
          },
          {
            featureType: "subway",
            elementType: "geometry",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,13",
              level: "12",
            },
          },
          {
            featureType: "subway",
            elementType: "geometry",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,13",
              level: "13",
            },
          },
          {
            featureType: "subwaylabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,13",
              level: "13",
            },
          },
          {
            featureType: "subwaylabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,13",
              level: "13",
            },
          },
          {
            featureType: "subwaylabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,13",
              level: "13",
            },
          },
          {
            featureType: "railway",
            elementType: "geometry",
            stylers: {
              visibility: "off",
            },
          },
          {
            featureType: "scenicspotslabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "10",
            },
          },
          {
            featureType: "scenicspotslabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "11",
            },
          },
          {
            featureType: "scenicspotslabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "12",
            },
          },
          {
            featureType: "scenicspotslabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "13",
            },
          },
          {
            featureType: "scenicspotslabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "14",
            },
          },
          {
            featureType: "scenicspotslabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "15",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "10",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "11",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "12",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "13",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "14",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "15",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "10",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "11",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "12",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "13",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "14",
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "10,15",
              level: "15",
            },
          },
          {
            featureType: "district",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "district",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "city",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "city",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "city",
            elementType: "labels.icon",
            stylers: {
              visibility: "on",
            },
          },
          {
            featureType: "country",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "country",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "continent",
            elementType: "labels.text.fill",
            stylers: {
              color: "#a77726ff",
            },
          },
          {
            featureType: "continent",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "medicallabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "13",
            },
          },
          {
            featureType: "medicallabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "14",
            },
          },
          {
            featureType: "medicallabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "15",
            },
          },
          {
            featureType: "medicallabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "16",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "13",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "14",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "15",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "16",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "13",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "14",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "15",
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "16",
            },
          },
          {
            featureType: "entertainmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "12",
            },
          },
          {
            featureType: "entertainmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "13",
            },
          },
          {
            featureType: "entertainmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "14",
            },
          },
          {
            featureType: "entertainmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "15",
            },
          },
          {
            featureType: "entertainmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "16",
            },
          },
          {
            featureType: "entertainmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "17",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "12",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "13",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "14",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "15",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "16",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "17",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "12",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "13",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "14",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "15",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "16",
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,17",
              level: "17",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "estatelabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "13",
            },
          },
          {
            featureType: "estatelabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "14",
            },
          },
          {
            featureType: "estatelabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "15",
            },
          },
          {
            featureType: "estatelabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "16",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "13",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "14",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "15",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "16",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "13",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "14",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "15",
            },
          },
          {
            featureType: "estatelabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,16",
              level: "16",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "businesstowerlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "12",
            },
          },
          {
            featureType: "businesstowerlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "13",
            },
          },
          {
            featureType: "businesstowerlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "14",
            },
          },
          {
            featureType: "businesstowerlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "15",
            },
          },
          {
            featureType: "businesstowerlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "16",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "12",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "13",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "14",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "15",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "16",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "12",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "13",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "14",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "15",
            },
          },
          {
            featureType: "businesstowerlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,16",
              level: "16",
            },
          },
          {
            featureType: "governmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "13",
            },
          },
          {
            featureType: "governmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "14",
            },
          },
          {
            featureType: "governmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "15",
            },
          },
          {
            featureType: "governmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "16",
            },
          },
          {
            featureType: "governmentlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "17",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "13",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "14",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "15",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "16",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "17",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "13",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "14",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "15",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "16",
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,17",
              level: "17",
            },
          },
          {
            featureType: "restaurantlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "13",
            },
          },
          {
            featureType: "restaurantlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "14",
            },
          },
          {
            featureType: "restaurantlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "15",
            },
          },
          {
            featureType: "restaurantlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "16",
            },
          },
          {
            featureType: "restaurantlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "17",
            },
          },
          {
            featureType: "restaurantlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "18",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "13",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "14",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "15",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "16",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "17",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "18",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "13",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "14",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "15",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "16",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "17",
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "13,18",
              level: "18",
            },
          },
          {
            featureType: "hotellabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "14",
            },
          },
          {
            featureType: "hotellabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "15",
            },
          },
          {
            featureType: "hotellabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "16",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 22,
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "14",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 22,
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "15",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 22,
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "16",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "14",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "15",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "16",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "14",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "15",
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "14,16",
              level: "16",
            },
          },
          {
            featureType: "shoppinglabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "11",
            },
          },
          {
            featureType: "shoppinglabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "12",
            },
          },
          {
            featureType: "shoppinglabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "13",
            },
          },
          {
            featureType: "shoppinglabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "14",
            },
          },
          {
            featureType: "shoppinglabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "15",
            },
          },
          {
            featureType: "shoppinglabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "16",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "11",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "12",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "13",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "14",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "15",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "16",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "11",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "12",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "13",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "14",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "15",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,16",
              level: "16",
            },
          },
          {
            featureType: "shoppinglabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "hotellabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "restaurantlabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "governmentlabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "companylabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 24,
            },
          },
          {
            featureType: "entertainmentlabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "medicallabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "scenicspotslabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "airportlabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffffff",
            },
          },
          {
            featureType: "manmade",
            elementType: "labels.text.fill",
            stylers: {
              color: "#9ca0a3ff",
            },
          },
          {
            featureType: "manmade",
            elementType: "labels.text.stroke",
            stylers: {
              color: "#ffffff00",
            },
          },
          {
            featureType: "education",
            elementType: "labels",
            stylers: {
              visibility: "on",
            },
          },
          {
            featureType: "transportationlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,13",
              level: "12",
            },
          },
          {
            featureType: "transportationlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "12,13",
              level: "13",
            },
          },
          {
            featureType: "transportationlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,13",
              level: "12",
            },
          },
          {
            featureType: "transportationlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,13",
              level: "13",
            },
          },
          {
            featureType: "transportationlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,13",
              level: "12",
            },
          },
          {
            featureType: "transportationlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "12,13",
              level: "13",
            },
          },
          {
            featureType: "educationlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "11",
            },
          },
          {
            featureType: "educationlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "12",
            },
          },
          {
            featureType: "educationlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "13",
            },
          },
          {
            featureType: "educationlabel",
            stylers: {
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "14",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "11",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "12",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "13",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "14",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "11",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "12",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "13",
            },
          },
          {
            featureType: "educationlabel",
            elementType: "labels.icon",
            stylers: {
              visibility: "off",
              curZoomRegionId: "0",
              curZoomRegion: "11,14",
              level: "14",
            },
          },
          {
            featureType: "transportationlabel",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "manmade",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "scenicspots",
            elementType: "labels.text.fill",
            stylers: {
              color: "#ab76b6ff",
            },
          },
          {
            featureType: "scenicspots",
            elementType: "labels.text",
            stylers: {
              fontsize: 23,
            },
          },
          {
            featureType: "water",
            elementType: "labels.text",
            stylers: {
              fontsize: 30,
            },
          },
        ],
      },
    };
  },
  watch: {
    "$store.state.wsRainData"(e) {
      this.normalRainCount = e.normalRainCount;
      this.normalSiteCount = e.normalSiteCount;
      this.offlineRainCount = e.offlineRainCount;
      this.offlineSiteCount = e.offlineSiteCount;
      this.warningRainCount = e.warningRainCount;
      this.warningSiteCount = e.warningSiteCount;
    },
    checkAll(e) {},
  },
  mounted() {
    this.show();
  },
  methods: {
    // 设备
    show() {
      getAllSiteList().then((res) => {
        // console.log('getAllSiteList', res)
        // this.center = res.data.siteVos[0]
        this.siteVos = res.data.siteVos;
        console.log('this.siteVos======',this.siteVos );
        this.rainVos = res.data.rainVos;
        this.ditchFlowMeters = res.data.ditchFlowMeters.map((item) => {
          return { ...item, lng: item.lon };
        });
        this.ditchFlowMeterCount = res.data.ditchFlowMeterCount;
        this.flowMeters = res.data.flowMeters.map((item) => {
          return { ...item, lng: item.lon };
        });
        this.flowMeterCount = res.data.flowMeterCount;
        this.pumpStations = res.data.pumpStations.map((item) => {
          return { ...item, lng: item.lon };
        });
        this.pumpStationCount = res.data.pumpStationCount;
        this.normalRainCount = res.data.normalRainCount;
        this.normalSiteCount = res.data.normalSiteCount;
        this.offlineRainCount = res.data.offlineRainCount;
        this.offlineSiteCount = res.data.offlineSiteCount;
        this.warningRainCount = res.data.warningRainCount;
        this.warningSiteCount = res.data.warningSiteCount;
      });
    },
    handleCheckAllChange(val) {
      // this.checkboxGroup2 = val ? cityOptions : [];
      // this.isIndeterminate = false;
      // if(val){
      //     this.showPumpStations=true
      //       this.showFlowMeters=true
      //       this.showSiteVos=true
      // }else{
      //      this.showPumpStations=false
      //       this.showFlowMeters=false
      //       this.showSiteVos=false
      // }
    },
    handleCheckedCitiesChange(value) {
      // console.log(value);
      if (value == "泵站") {
        this.showPumpStations = true;
        this.showSiteVos = false;
        this.showFlowMeters = false;
      }
      if (value == "测流点") {
        this.showFlowMeters = true;
        this.showPumpStations = false;
        this.showSiteVos = false;
      }
      if (value == "节制闸") {
        this.showSiteVos = true;
        this.showPumpStations = false;
        this.showFlowMeters = false;
      }
      if (value == "全选") {
        this.showSiteVos = true;
        this.showPumpStations = true;
        this.showFlowMeters = true;
      }
    },
    goPush(id) {
      this.$router.push({ path: `/main/StationManage/${id}` });
    },
    toPumpStationPush(id, staId) {
      this.$router.push({ path: `/main/pumpStation/${id}/1-1` });
    },
    // 打开信息窗口
    openInfoBox(lng, lat, id) {
      // 鼠标移入获取接口数据
      getSiteByIdList({ id: id }).then((res) => {
        this.isMains = res.data.isMains;
        this.alarmStatus = res.data.alarmStatus;
        this.siteItemVo = res.data.siteItemVo;
        this.gateVo = res.data.gateVo;
        // <div class="rainBox_title_img" οnclick="closeBtn" >
        //             <img src="https://qiniu1.xuruidea.com/23001611824666_.pic_hd.jpg"  alt="" />
        //           </div>
        let html1 = `<div class="rain" style="position: absolute;
    z-index: 9;">
    <div class="rainBox">
      <div style="margin:0 12px">
        <!-- 头部区域 -->
        <div class="rainBox_title flex flex-a-c ">
          <div class="rainBox_title_num ">
            <span style="font-size:12px">${this.siteItemVo.updateTime}</span>
          </div>
          <div
            class="rainBox_title_text  font-w-b"
            style="color:#333333;font-size:14px"
          >
           ${this.siteItemVo.siteName}

          </div>

        </div>
        <div class="polyin"></div>
        <!-- 闸门信息 -->
        <div class="gate">
          <div class="gate_title flex flex-a-c ">
            <p class="font-w-b" style="font-size:14px">闸门信息</p>
          </div>
          <div class="gate_text">
            <ul class="flex ul_one">
              <li>
                <div class=" font-w-b t-x" style="color:#11B36C;font-size:16px;">
                 ${this.gateVo.gateHeight}
                </div>
              </li>
              <li>
                <div class=" font-w-b t-x" style="color:#00a0e9;font-size:16px">
               ${this.gateVo.gateHeightLimit}
                </div>
              </li>
              <li>
                `;
        if (this.siteItemVo.deviceStatus == 0 && this.gateVo.gateHeight > 5) {
          html1 += `<div class=" font-w-b t-x" style="color:#1B9EE8;font-size:16px;">
                 运行中
                </div>`;
        } else if (
          this.siteItemVo.deviceStatus == 0 &&
          this.gateVo.gateHeight <= 5
        ) {
          html1 += `<div class=" font-w-b t-x" style="color:red;font-size:16px;">
                 停止
                </div>`;
        } else if (this.siteItemVo.deviceStatus == 1) {
          html1 += `<div class=" font-w-b t-x" style="color:#999999;font-size:16px;">
                 离线
                </div>`;
        }
        html1 += `</li>
              <li>
                `;
        if (this.siteItemVo.longRange == 0) {
          html1 += `<div class=" font-w-b t-x" style="color:black;font-size:16px">
               本地
                </div>`;
        } else if (this.siteItemVo.longRange == 1) {
          html1 += `<div class=" font-w-b t-x" style="color:#00a0e9;font-size:16px">
               远程
                </div>`;
        }
        html1 += `</li>
            </ul>
            <ul class="flex ul_two">
              <li>
                <div class=" t-x font-s-12" style="color:#333333;font-weight: bold;">
                  闸门高度(cm)
                </div>
              </li>
              <li>
                <div class=" t-x font-s-12" style="color:#333333;font-weight: bold;">
                  闸门限高(cm)
                </div>
              </li>
              <li>
                <div class=" t-x font-s-12" style="color:#333333;font-weight: bold;">
                  闸门状态
                </div>
              </li>
              <li>
                <div class=" t-x font-s-12" style="color:#333333;font-weight: bold;">
                  闸门控制
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="polyin"></div>
        <!-- 水文信息 -->
        <div class="waterMes">
          <div class="waterMes_title flex flex-a-c ">
            <p class="font-w-b" style="font-size:14px">水文信息</p>
          </div>
          <div class="waterMes_text">
            <ul class="flex ul_one" style="flex-wrap: wrap;">
              <li class="flex">
                <div class="font-s-12" style="color:#666;margin:0 0 4px 4px">
                  闸前水位：
                </div>`;
        if (this.siteItemVo.gateLevel >= this.siteItemVo.warningLevel) {
          html1 += `
                <div class="font-w-b font-s-12" style="color:red;">
                ${this.siteItemVo.gateLevel}(cm)
                </div>`;
        } else {
          html1 += `
                <div class="font-w-b font-s-12" style="color:#1B9EE8">
                ${this.siteItemVo.gateLevel}(cm)
                </div>`;
        }
        html1 += `
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin:0 0 4px 4px">
                  闸后水位：
                </div>
                <div class="font-w-b t-x font-s-12" style="color:#1B9EE8">
                  ${this.siteItemVo.currentLevel}(cm)
                </div>
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin:0 0 4px 4px">
                  警戒水位：
                </div>
                <div class="font-w-b t-x font-s-12" style="color:#1B9EE8">
                  ${this.siteItemVo.warningLevel}(cm)
                </div>
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin:0 0 4px 4px">
                  瞬时流量：
                </div>
                <div class="font-w-b t-x font-s-12" style="color:#1B9EE8">
                  ${this.siteItemVo.traffic}(m³/h)
                </div>
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin:0 0 4px 4px">
                  流&emsp;&emsp;速：
                </div>
                <div class="font-w-b t-x font-s-12" style="color:#1B9EE8">
                  ${this.siteItemVo.velocity}(m/s)
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="polyin"></div>
        <!-- 市电信息 -->
        <div class="mete">
          <div class="mete_title flex flex-a-c ">
            <p class="font-w-b" style="font-size:14px">市电信息</p>
          </div>
          <div class="mete_text">
            <ul class="flex ul_two">
              <li class="flex">
                <div class="font-s-12" style="color:#666;margin-left:4px">
                  B相电流：
                </div>
                <div class="font-w-b font-s-12" style="color:#1B9EE8">
                ${this.siteItemVo.bCurrent}(A)
                </div>
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin-left:4px">
                  B相电压：
                </div>
                <div class="font-w-b t-x font-s-12" style="color:#1B9EE8">
                  ${this.siteItemVo.bVoltage}(V)
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="polyin"></div>
        <div class="solar">
          <div class="solar_title flex flex-a-c ">
            <p class="font-w-b" style="font-size:14px">安防报警</p>
          </div>
          <div class="solar_text">
            <ul class="flex ul_two">
              <li class="flex">
                <div class="font-s-12" style="color:#666;margin-left:4px">
                  门禁预警：
                </div>`;
        if (this.alarmStatus.accessControlStatus == 0) {
          html1 += `<div class="font-w-b font-s-12" style="color:#11B36C">
                正常
                </div>`;
        } else {
          html1 += `<div class="font-w-b font-s-12" style="color:#FA2626" v-else>
                报警
                </div>`;
        }
        html1 += `
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin-left:4px">
                  周界预警：
                </div>`;
        if (this.alarmStatus.perimeterStatus == 0) {
          html1 += `<div class="font-w-b font-s-12" style="color:#11B36C">
                正常
                </div>`;
        } else {
          html1 += `<div class="font-w-b font-s-12" style="color:#FA2626" v-else>
                报警
                </div>`;
        }

        html1 += `
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>`;

        // <div class="rainBox_title_img" οnclick="closeBtn">
        //             <img src="https://qiniu1.xuruidea.com/23001611824666_.pic_hd.jpg"  alt="" />
        //           </div>
        // 闸门
        let html = `<div class="rain" style="position: absolute;
    z-index: 9;">
    <div class="rainBox">
      <div style="margin:0 12px">
        <!-- 头部区域 -->
        <div class="rainBox_title flex flex-a-c ">
          <div class="rainBox_title_num ">
            <span style="font-size:12px">${this.siteItemVo.updateTime}</span>
          </div>
          <div
            class="rainBox_title_text  font-w-b"
            style="color:#333333;font-size:14px"
          >
           ${this.siteItemVo.siteName}

          </div>

        </div>
        <div class="polyin"></div>
        <!-- 闸门信息 -->
        <div class="gate">
          <div class="gate_title flex flex-a-c ">
            <p class="font-w-b" style="font-size:14px">闸门信息</p>
          </div>
          <div class="gate_text">
            <ul class="flex ul_one">
              <li>
                <div class=" font-w-b t-x" style="color:#11B36C;font-size:16px;">
                 ${this.gateVo.gateHeight}
                </div>
              </li>
              <li>
                <div class=" font-w-b t-x" style="color:red;font-size:16px">
               ${this.gateVo.gateHeightLimit}
                </div>
              </li>
              <li>
                `;
        if (this.siteItemVo.deviceStatus == 0 && this.gateVo.gateHeight > 5) {
          html += `<div class=" font-w-b t-x" style="color:#1B9EE8;font-size:16px;">
                 运行中
                </div>`;
        } else if (
          this.siteItemVo.deviceStatus == 0 &&
          this.gateVo.gateHeight <= 5
        ) {
          html += `<div class=" font-w-b t-x" style="color:red;font-size:16px;">
                 停止
                </div>`;
        } else if (this.siteItemVo.deviceStatus == 1) {
          html += `<div class=" font-w-b t-x" style="color:#999999;font-size:16px;">
                 离线
                </div>`;
        }
        html += `</li>
              <li>
                `;
        if (this.siteItemVo.longRange == 0) {
          html += `<div class=" font-w-b t-x" style="color:black;font-size:16px">
               本地
                </div>`;
        } else if (this.siteItemVo.longRange == 1) {
          html += `<div class=" font-w-b t-x" style="color:#00a0e9;font-size:16px">
               远程
                </div>`;
        }
        html += `</li>
            </ul>
            <ul class="flex ul_two">
              <li>
                <div class=" t-x font-s-12" style="color:#333333;font-weight: bold;">
                  闸门高度(cm)
                </div>
              </li>
              <li>
                <div class=" t-x font-s-12" style="color:#333333;font-weight: bold;">
                  闸门限高(cm)
                </div>
              </li>
              <li>
                <div class=" t-x font-s-12" style="color:#333333;font-weight: bold;">
                  闸门状态
                </div>
              </li>
              <li>
                <div class=" t-x font-s-12" style="color:#333333;font-weight: bold;">
                  闸门控制
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="polyin"></div>
        <!-- 水文信息 -->
        <div class="waterMes">
          <div class="waterMes_title flex flex-a-c ">
            <p class="font-w-b" style="font-size:14px">水文信息</p>
          </div>
          <div class="waterMes_text">
            <ul class="flex ul_one" style="flex-wrap: wrap;">
              <li class="flex">
                <div class="font-s-12" style="color:#666;margin:0 0 4px 4px">
                  闸前水位：
                </div>
               `;
        if (this.siteItemVo.gateLevel >= this.siteItemVo.warningLevel) {
          html += `
                <div class="font-w-b font-s-12" style="color:red;">
                ${this.siteItemVo.gateLevel}(cm)
                </div>`;
        } else {
          html += `
                <div class="font-w-b font-s-12" style="color:#1B9EE8">
                ${this.siteItemVo.gateLevel}(cm)
                </div>`;
        }
        html += `
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin:0 0 4px 4px">
                  闸后水位：
                </div>
                <div class="font-w-b t-x font-s-12" style="color:#1B9EE8">
                  ${this.siteItemVo.currentLevel}(cm)
                </div>
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin:0 0 4px 4px">
                  警戒水位：
                </div>
                <div class="font-w-b t-x font-s-12" style="color:#1B9EE8">
                  ${this.siteItemVo.warningLevel}(cm)
                </div>
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin:0 0 4px 4px">
                  瞬时流量：
                </div>
                <div class="font-w-b t-x font-s-12" style="color:#1B9EE8">
                  ${this.siteItemVo.traffic}(m³/h)
                </div>
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin:0 0 4px 4px">
                  流&emsp;&emsp;速：
                </div>
                <div class="font-w-b t-x font-s-12" style="color:#1B9EE8">
                  ${this.siteItemVo.velocity}(m/s)
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="polyin"></div>
        <!-- 市电信息 -->
        <div class="mete">
          <div class="mete_title flex flex-a-c ">
            <p class="font-w-b" style="font-size:14px">市电信息</p>
          </div>
          <div class="mete_text">
            <ul class="flex ul_two">
              <li class="flex">
                <div class="font-s-12" style="color:#666;margin-left:4px">
                  B相电流：
                </div>
                <div class="font-w-b font-s-12" style="color:#1B9EE8">
                ${this.siteItemVo.bCurrent}(A)
                </div>
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin-left:4px">
                  B相电压：
                </div>
                <div class="font-w-b t-x font-s-12" style="color:#1B9EE8">
                  ${this.siteItemVo.bVoltage}(V)
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="polyin"></div>
        <div class="solar">
          <div class="solar_title flex flex-a-c ">
            <p class="font-w-b" style="font-size:14px">安防报警</p>
          </div>
          <div class="solar_text">
            <ul class="flex ul_two">
              <li class="flex">
                <div class="font-s-12" style="color:#666;margin-left:4px">
                  门禁预警：
                </div>`;
        if (this.alarmStatus.accessControlStatus == 0) {
          html += `<div class="font-w-b font-s-12" style="color:#11B36C">
                正常
                </div>`;
        } else {
          html += `<div class="font-w-b font-s-12" style="color:#FA2626" v-else>
                报警
                </div>`;
        }
        html += `
              </li>
              <li class="flex">
                <div class="t-x font-s-12" style="color:#666;margin-left:4px">
                  周界预警：
                </div>`;
        if (this.alarmStatus.perimeterStatus == 0) {
          html += `<div class="font-w-b font-s-12" style="color:#11B36C">
                正常
                </div>`;
        } else {
          html += `<div class="font-w-b font-s-12" style="color:#FA2626" v-else>
               报警
                </div>`;
        }

        html += `
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>`;

        const opts = {
          boxStyle: {
            width: "400px",
            height: "350px",
          },
          closeIconMargin: "calc(50/1080*100vh) calc(20/1920*100vw) 0 0",
          closeIconUrl: require("../../../.././assets/images/index/guanbi.png"),
          enableAutoPan: true,
          align: INFOBOX_AT_TOP,
        };

        if (this.isMains == 1) {
          this.infoBox = new BMapLib.InfoBox(this.map, html1, opts);
        } else {
          this.infoBox = new BMapLib.InfoBox(this.map, html, opts);
        }
        const point = new BMap.Point(lng, lat);
        const marker = new BMap.Marker(point);
        if (this.lastInfoBox) {
          // 判断上一个窗体是否存在，若存在则执行close
          this.lastInfoBox.close();
        }
        this.lastInfoBox = this.infoBox;
        this.infoBox.open(marker);
        document.querySelector(".map-checkbox").style.opacity = 0; // 隐藏雨情控件
        document.querySelector(".map-data-tip").style.opacity = 0; // 隐藏雨情控件
        document.querySelector(".icoQuan").style.opacity = 0; // 隐藏雨情控件
        var guanbiBtn =
          window.document.getElementsByClassName("rainBox_title_img");
        var that = this;
        guanbiBtn[0].addEventListener("click", showMsg, false); // 鼠标单击的时候调用showMes这个函数
        function showMsg() {
          // alert("事件监听");
          that.infoBox.close();
          document.querySelector(".map-checkbox").style.opacity = 1; // 显示雨情控件
          document.querySelector(".map-data-tip").style.opacity = 1; // 显示雨情控件
          document.querySelector(".icoQuan").style.opacity = 1; // 显示雨情控件
        }
      });
    },

    closeInfoBox() {
      if (this.infoBox !== null) {
        this.infoBox.close();
        document.querySelector(".map-checkbox").style.opacity = 1; // 显示雨情控件
        document.querySelector(".map-data-tip").style.opacity = 1; // 显示雨情控件
        document.querySelector(".icoQuan").style.opacity = 1; // 显示雨情控件
      }
    },
    mouseoutMap() {
      this.lastInfoBox.close();
    },
    mouseoverMap() {
      this.lastInfoBox.close();
    },
    // 渠道流量计弹框
    openDitchFlowMeterBox(lng, lat, id) {
      getDitchFlowMeter({ meterId: id }).then((res) => {
        // 渠道流量计
        const qdlljHtml = qdllj(res.data);
        const opts = {
          boxStyle: {
            width: "420px",
            height: "360px",
          },
          closeIconMargin: "calc(50/1080*100vh) calc(20/1920*100vw) 0 0",
          closeIconUrl: require("../../../.././assets/images/index/guanbi.png"),
          enableAutoPan: true,
          align: INFOBOX_AT_TOP,
        };

        this.infoBox = new BMapLib.InfoBox(this.map, qdlljHtml, opts);
        const point = new BMap.Point(lng, lat);
        const marker = new BMap.Marker(point);
        if (this.lastInfoBox) {
          // 判断上一个窗体是否存在，若存在则执行close
          this.lastInfoBox.close();
        }
        this.lastInfoBox = this.infoBox;
        this.infoBox.open(marker);
        document.querySelector(".map-checkbox").style.opacity = 0; // 隐藏雨情控件
        document.querySelector(".map-data-tip").style.opacity = 0; // 隐藏雨情控件
        document.querySelector(".icoQuan").style.opacity = 0; // 隐藏雨情控件
        var guanbiBtn = window.document.getElementsByClassName("title_img");
        var that = this;
        guanbiBtn[0].addEventListener("click", showMsg, false); // 鼠标单击的时候调用showMes这个函数
        function showMsg() {
          // alert("事件监听");
          that.infoBox.close();
          document.querySelector(".map-checkbox").style.opacity = 1; // 显示雨情控件
          document.querySelector(".map-data-tip").style.opacity = 1; // 显示雨情控件
          document.querySelector(".icoQuan").style.opacity = 1; // 显示雨情控件
        }
      });
    },

    closeDitchFlowMeterBox() {
      if (this.infoBox !== null) {
        this.infoBox.close();
        document.querySelector(".map-checkbox").style.opacity = 1; // 显示雨情控件
        document.querySelector(".map-data-tip").style.opacity = 1; // 显示雨情控件
        document.querySelector(".icoQuan").style.opacity = 1; // 显示雨情控件
      }
    },

    // 流量计弹框
    openFlowMeterBox(lng, lat, id) {
      getFlowMeter({ devSn: id }).then((res) => {
        // console.log(res)
        // 渠道流量计
        const lljHtml = llj(res.data);
        const opts = {
          boxStyle: {
            width: "420px",
            height: "360px",
          },
          closeIconMargin: "calc(50/1080*100vh) calc(20/1920*100vw) 0 0",
          closeIconUrl: require("../../../.././assets/images/index/guanbi.png"),
          enableAutoPan: true,
          align: INFOBOX_AT_TOP,
        };

        this.infoBox = new BMapLib.InfoBox(this.map, lljHtml, opts);
        const point = new BMap.Point(lng, lat);
        const marker = new BMap.Marker(point);
        if (this.lastInfoBox) {
          // 判断上一个窗体是否存在，若存在则执行close
          this.lastInfoBox.close();
        }
        this.lastInfoBox = this.infoBox;
        this.infoBox.open(marker);
        document.querySelector(".map-checkbox").style.opacity = 0; // 隐藏雨情控件
        document.querySelector(".map-data-tip").style.opacity = 0; // 隐藏雨情控件
        document.querySelector(".icoQuan").style.opacity = 0; // 隐藏雨情控件
        var guanbiBtn = window.document.getElementsByClassName("title_img");
        var that = this;
        guanbiBtn[0].addEventListener("click", showMsg, false); // 鼠标单击的时候调用showMes这个函数
        function showMsg() {
          // alert("事件监听");
          that.infoBox.close();
          document.querySelector(".map-checkbox").style.opacity = 1; // 显示雨情控件
          document.querySelector(".map-data-tip").style.opacity = 1; // 显示雨情控件
          document.querySelector(".icoQuan").style.opacity = 1; // 显示雨情控件
        }
      });
    },

    closeFlowMeterBox() {
      if (this.infoBox !== null) {
        this.infoBox.close();
        document.querySelector(".map-checkbox").style.opacity = 1; // 显示雨情控件
        document.querySelector(".map-data-tip").style.opacity = 1; // 显示雨情控件
        document.querySelector(".icoQuan").style.opacity = 1; // 显示雨情控件
      }
    },

    // 泵站弹框
    openPumpMeterBox(lng, lat, id) {
      getPumpStation({ id: id }).then((res) => {
        const bzHtml = bz(res.data);
        const opts = {
          boxStyle: {
            width: "420px",
            height: "310px",
          },
          closeIconMargin: "calc(50/1080*100vh) calc(20/1920*100vw) 0 0",
          closeIconUrl: require("../../../.././assets/images/index/guanbi.png"),
          enableAutoPan: true,
          align: INFOBOX_AT_TOP,
        };

        this.infoBox = new BMapLib.InfoBox(this.map, bzHtml, opts);
        const point = new BMap.Point(lng, lat);
        const marker = new BMap.Marker(point);
        if (this.lastInfoBox) {
          // 判断上一个窗体是否存在，若存在则执行close
          this.lastInfoBox.close();
        }
        this.lastInfoBox = this.infoBox;
        this.infoBox.open(marker);
        document.querySelector(".map-checkbox").style.opacity = 0; // 隐藏雨情控件
        document.querySelector(".map-data-tip").style.opacity = 0; // 隐藏雨情控件
        document.querySelector(".icoQuan").style.opacity = 0; // 隐藏雨情控件
        var guanbiBtn = window.document.getElementsByClassName("title_img");
        var that = this;
        guanbiBtn[0].addEventListener("click", showMsg, false); // 鼠标单击的时候调用showMes这个函数
        function showMsg() {
          // alert("事件监听");
          that.infoBox.close();
          document.querySelector(".map-checkbox").style.opacity = 1; // 显示雨情控件
          document.querySelector(".map-data-tip").style.opacity = 1; // 显示雨情控件
          document.querySelector(".icoQuan").style.opacity = 1; // 显示雨情控件
        }
      });
    },

    closePumpBox() {
      if (this.infoBox !== null) {
        this.infoBox.close();
        document.querySelector(".map-checkbox").style.opacity = 1; // 显示雨情控件
        document.querySelector(".map-data-tip").style.opacity = 1; // 显示雨情控件
        document.querySelector(".icoQuan").style.opacity = 1; // 显示雨情控件
      }
    },

    // 雨情弹框
    openRainBox(lng, lat, id, rainName) {
      getRainById({ id, id }).then((res) => {
        this.rainfallTime = res.data.rainfallTime;
        this.rainfall = res.data.rainfall;
        const RainHtml = `
      <div class="RainBox">
      <button>${rainName}</button>
      <div><span>降雨量：</span><span>${this.rainfall}mm</span></div>
      <div class="timer"><span>降雨时长：</span><span>${this.rainfallTime}</span></div>
      </div>
      `;
        const opts = {
          boxStyle: {
            width: "calc(242/1920*100vw)",
            height: "calc(120/1080*100vh)",
          },
          closeIconMargin: "calc(15/1080*100vh) calc(10/1920*100vw) 0 0",
          closeIconUrl: require("../../../.././assets/images/index/rain.png"),
          enableAutoPan: true,
          align: INFOBOX_AT_TOP,
        };
        this.infoBox = new BMapLib.InfoBox(this.map, RainHtml, opts);
        const point = new BMap.Point(lng, lat);
        const marker = new BMap.Marker(point);
        if (this.lastInfoBox) {
          // 判断上一个窗体是否存在，若存在则执行close
          this.lastInfoBox.close();
        }
        this.lastInfoBox = this.infoBox;
        this.infoBox.open(marker);
      });
    },
    // 自定义经纬度高亮区域 根据自定义经纬度展示其余遮罩
    handler({ BMap, map }) {
      this.map = map;
      this.getBoundary(this.map, "兰考县");
    },
    getBoundary(map, district) {
      var bdary = new BMap.Boundary();
      bdary.get(district, function (rs) {
        // 获取行政区域
        // map.clearOverlays(); //清除地图覆盖物
        var count = rs.boundaries.length; // 行政区域的点有多少个
        if (count === 0) {
          /* alert('未能获取当前输入行政区域'); */
          return;
        }
        const EN_JW = "180, 90;";
        const NW_JW = "-180,  90;";
        const WS_JW = "-180, -90;";
        const SE_JW = "180, -90;";
        // 东南西北四个角添加一个覆盖物
        const ply1 = new BMap.Polygon(
          rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW,
          {
            strokeColor: "none",
            fillColor: "#fff",
            fillOpacity: 1,
            strokeOpacity: 1,
          }
        );
        map.addOverlay(ply1);
        var pointArray = [];
        for (var i = 0; i < count; i++) {
          var ply = new BMap.Polygon(rs.boundaries[i], {
            strokeWeight: 2, // 设置多边形边线线粗
            strokeOpacity: 1, // 设置多边形边线透明度0-1
            StrokeStyle: "dashed", // 设置多边形边线样式为实线或虚线，取值 solid 或 dashed
            strokeColor: "#009944", // 设置多边形边线颜色
            fillColor: "#8BFFCC", // 设置多边形填充颜色
            fillOpacity: 0.13, // 设置多边形填充颜色透明度0-1  注：标红的地放你们可以去掉看一下效果，自己体验一下
          }); // 建立多边形覆盖物
          map.addOverlay(ply); // 添加覆盖物
          // pointArray = pointArray.concat(ply.getPath())
        }
        // map.setViewport(pointArray) // 调整视野
      });
    },

    // // 画地图虚线高亮展示
    // getBoundary(param, map) {
    //   var bdary = new BMap.Boundary();
    //   let boundariesValue = [
    //     "118.221952, 37.391765;118.2225, 37.391591;118.223152, 37.391392;118.223567, 37.390599;118.224389, 37.386527;118.224794, 37.382918;118.224784, 37.379937;118.224702, 37.379028;118.224753, 37.378613;118.224909, 37.378362;118.225378, 37.378043;118.226005, 37.377845;118.228095, 37.377535;118.229191, 37.3771;118.229451, 37.376784;118.229657, 37.376159;118.229627, 37.375;118.229782, 37.374355;118.230094, 37.374018;118.230774, 37.373735;118.231349, 37.373702;118.231819, 37.373775;118.232761, 37.373983;118.237473, 37.37527;118.238833, 37.375427;118.239304, 37.375439;118.239775, 37.375428;118.240716, 37.375181;118.241967, 37.374306;118.243063, 37.373683;118.243977, 37.373333;118.245256, 37.37306;118.247138, 37.373024;118.249124, 37.373237;118.250876, 37.373683;118.25289, 37.374769;118.253832, 37.375543;118.253938, 37.376141;118.253968, 37.377238;118.253481, 37.379708;118.253016, 37.381165;118.252967, 37.381807;118.253072, 37.382054;118.253516, 37.382337;118.253829, 37.382395;118.254456, 37.382386;118.254977, 37.382316;118.255708, 37.382306;118.256203, 37.382446;118.256935, 37.382789;118.257379, 37.383053;118.258295, 37.384119;118.258765, 37.384466;118.25934, 37.384874;118.260253, 37.385466;118.261139, 37.385707;118.262286, 37.38578;118.263248, 37.385692;118.264184, 37.38521;118.265245, 37.384005;118.266539, 37.381867;118.267285, 37.379712;118.267897, 37.376358;118.268095, 37.373501;118.268452, 37.371699;118.268839, 37.370953;118.269304, 37.370166;118.270235, 37.369255;118.271867, 37.368326;118.27451, 37.3673;118.277178, 37.366694;118.278809, 37.366499;118.280311, 37.366533;118.281659, 37.366836;118.283369, 37.367289;118.285415, 37.36777;118.288185, 37.368304;118.290641, 37.368505;118.292372, 37.368324;118.293353, 37.367822;118.29518, 37.36578;118.296467, 37.364288;118.296826, 37.363776;118.296954, 37.363406;118.296848, 37.362846;118.295915, 37.362188;118.294774, 37.361218;118.294099, 37.360421;118.293992, 37.359488;118.29404, 37.358888;118.294143, 37.35862;118.294426, 37.358355;118.294942, 37.358178;118.295975, 37.358007;118.297603, 37.357846;118.301866, 37.357561;118.308565, 37.35788;118.313535, 37.358015;118.319291, 37.358238;118.320666, 37.358285;118.321599, 37.358018;118.321935, 37.357666;118.322141, 37.357314;118.32227, 37.356983;118.322268, 37.356507;118.322187, 37.355844;118.32183, 37.351495;118.32151, 37.344473;118.321429, 37.338819;118.321277, 37.334593;118.321051, 37.331029;118.321658, 37.328131;118.322539, 37.322933;118.323758, 37.317713;118.324367, 37.315124;118.324802, 37.313756;118.325162, 37.313175;118.325525, 37.312947;118.326252, 37.312758;118.326798, 37.312757;118.3288, 37.312748;118.330206, 37.312678;118.331116, 37.312485;118.332232, 37.311979;118.332906, 37.311207;118.333316, 37.309939;118.333621, 37.308218;118.333588, 37.307017;118.33332, 37.30559;118.333289, 37.304534;118.333262, 37.304183;118.333493, 37.303517;118.33383, 37.303017;118.334814, 37.301847;118.335879, 37.301151;118.336843, 37.300767;118.337546, 37.300675;118.339164, 37.300633;118.342924, 37.300904;118.344961, 37.300869;118.346059, 37.300848;118.347103, 37.300726;118.348017, 37.300418;118.348981, 37.299943;118.349684, 37.299349;118.350257, 37.298985;118.350519, 37.298876;118.350962, 37.298826;118.351564, 37.298814;118.352898, 37.298889;118.353657, 37.298935;118.354049, 37.298927;118.354283, 37.29884;118.354779, 37.298621;118.354884, 37.298412;118.354906, 37.297708;118.354669, 37.29736;118.353908, 37.296734;118.353175, 37.296585;118.352522, 37.296599;118.351111, 37.29698;118.350537, 37.297033;118.350091, 37.297001;118.349751, 37.296863;118.349043, 37.296297;118.348936, 37.295761;118.348984, 37.294766;118.349581, 37.293657;118.35031, 37.293144;118.351094, 37.292983;118.351773, 37.292928;118.353943, 37.292862;118.356062, 37.292817;118.358521, 37.293012;118.359775, 37.292986;118.360846, 37.292757;118.362466, 37.292392;118.363589, 37.291955;118.364162, 37.291509;118.364395, 37.291007;118.364472, 37.290612;118.36447, 37.290198;118.364572, 37.28945;118.364648, 37.289035;118.364905, 37.288036;118.366127, 37.286377;118.367118, 37.285799;118.367979, 37.285369;118.36884, 37.285167;118.369832, 37.28515;118.372887, 37.285308;118.374531, 37.285263;118.375077, 37.284904;118.375337, 37.28457;118.375413, 37.284299;118.375464, 37.283656;118.375409, 37.283078;118.375251, 37.282707;118.374674, 37.281949;118.374073, 37.281398;118.373706, 37.281321;118.373445, 37.281324;118.373081, 37.281392;118.37183, 37.28195;118.370945, 37.28244;118.370631, 37.282528;118.370318, 37.282533;118.370031, 37.282496;118.369716, 37.282337;118.369455, 37.282051;118.369349, 37.281784;118.369191, 37.281413;118.369137, 37.280897;118.36924, 37.280419;118.370177, 37.279907;118.371299, 37.279597;118.372238, 37.279438;118.373804, 37.279497;118.37558, 37.279784;118.3767, 37.279749;118.377612, 37.27949;118.378184, 37.279028;118.37987, 37.276899;118.381189, 37.274404;118.381805, 37.271832;118.382501, 37.267907;118.382587, 37.267427;118.386132, 37.267461;118.391709, 37.267222;118.39446, 37.267207;118.395146, 37.267404;118.39616, 37.267868;118.396675, 37.268607;118.396897, 37.269282;118.397078, 37.273086;118.397609, 37.276991;118.397832, 37.277773;118.397956, 37.277936;118.398078, 37.27802;118.398243, 37.278068;118.398419, 37.278106;118.398596, 37.278104;118.398828, 37.278103;118.399084, 37.278065;118.400286, 37.277731;118.401154, 37.27756;118.401966, 37.27748;118.402437, 37.277476;118.403041, 37.277604;118.403454, 37.277776;118.403666, 37.277934;118.403912, 37.278187;118.404069, 37.278386;118.404146, 37.278649;118.404256, 37.278963;118.404239, 37.27941;118.404108, 37.279845;118.403625, 37.280864;118.403486, 37.281602;118.403653, 37.282149;118.403787, 37.282407;118.404058, 37.282655;118.404328, 37.282833;118.40476, 37.283;118.405138, 37.283077;118.405515, 37.283096;118.407379, 37.282928;118.40768, 37.282957;118.407921, 37.283036;118.408295, 37.283354;118.408606, 37.28411;118.408858, 37.285938;118.409167, 37.287351;118.409376, 37.28763;118.409567, 37.287759;118.409909, 37.287857;118.410162, 37.287916;118.410639, 37.287945;118.412944, 37.287911;118.413121, 37.28797;118.413288, 37.288079;118.413446, 37.288318;118.413528, 37.288517;118.413571, 37.288736;118.413474, 37.28902;118.412948, 37.289809;118.411843, 37.290926;118.411358, 37.291844;118.411227, 37.292821;118.411346, 37.293827;118.411786, 37.295062;118.412589, 37.296421;118.413495, 37.297355;118.414224, 37.297803;118.414988, 37.29818;118.415368, 37.298279;118.415895, 37.298298;118.416132, 37.298297;118.416319, 37.298257;118.416452, 37.298127;118.416521, 37.297919;118.41659, 37.297739;118.416569, 37.297091;118.416503, 37.295688;118.416519, 37.295589;118.416547, 37.295509;118.416711, 37.295344;118.416847, 37.29528;118.417681, 37.295108;118.418104, 37.295048;118.418331, 37.295052;118.418538, 37.295082;118.418672, 37.295157;118.418809, 37.295316;118.419314, 37.29683;118.420679, 37.299508;118.421418, 37.301041;118.421767, 37.301389;118.421973, 37.301538;118.427741, 37.304473;118.428324, 37.304659;118.428817, 37.304766;118.429017, 37.304765;118.429229, 37.304724;118.429365, 37.304643;118.429435, 37.304493;118.429464, 37.304225;118.42937, 37.303637;118.428968, 37.302852;118.427949, 37.301592;118.427697, 37.30098;118.427618, 37.300502;118.427647, 37.300203;118.427738, 37.299913;118.427894, 37.299704;118.428016, 37.299594;118.428152, 37.299513;118.428436, 37.299402;118.428786, 37.29933;118.429475, 37.299327;118.42996, 37.299562;118.430385, 37.299908;118.430519, 37.300177;118.43059, 37.300405;118.430667, 37.300893;118.430802, 37.301151;118.430918, 37.301271;118.43111, 37.301358;118.431351, 37.301447;118.431667, 37.301515;118.431969, 37.301532;118.432555, 37.301408;118.433828, 37.301138;118.434204, 37.301114;118.434568, 37.301111;118.434986, 37.301207;118.435521, 37.301563;118.435873, 37.301953;118.436087, 37.302519;118.437217, 37.30577;118.437352, 37.306048;118.437494, 37.306165;118.43771, 37.306223;118.438038, 37.306269;118.44188, 37.306364;118.443825, 37.306511;118.446454, 37.306934;118.449578, 37.307533;118.45166, 37.308066;118.452041, 37.308136;118.452269, 37.308141;118.452471, 37.308135;118.452633, 37.308081;118.45277, 37.307998;118.452892, 37.307865;118.452964, 37.307753;118.453044, 37.307482;118.453023, 37.307224;118.4525, 37.305952;118.451385, 37.303918;118.449313, 37.301351;118.448658, 37.30023;118.448533, 37.299495;118.448497, 37.29906;118.448544, 37.298765;118.448748, 37.298237;118.449107, 37.297831;118.449374, 37.297593;118.449679, 37.297461;118.449855, 37.297426;118.450081, 37.297407;118.450979, 37.297435;118.453715, 37.297458;118.457262, 37.297504;118.458237, 37.297519;118.458369, 37.297515;118.458478, 37.297536;118.458625, 37.297592;118.458793, 37.297681;118.459008, 37.297864;118.459185, 37.298078;118.459351, 37.298306;118.459457, 37.298656;118.459552, 37.299012;118.460446, 37.301488;118.461139, 37.302929;118.462418, 37.306763;118.462869, 37.308153;118.463071, 37.308526;118.463244, 37.308748;118.463557, 37.309057;118.463947, 37.309322;118.464219, 37.309482;118.464525, 37.309572;118.464805, 37.309601;118.465313, 37.309604;118.468308, 37.309479;118.472579, 37.309717;118.474955, 37.309786;118.475447, 37.309697;118.475762, 37.309625;118.476237, 37.309387;118.476497, 37.309228;118.476644, 37.309032;118.476884, 37.308645;118.476953, 37.308393;118.476936, 37.30809;118.475524, 37.306061;118.475483, 37.305604;118.475473, 37.305295;118.475538, 37.304964;118.475768, 37.304597;118.475902, 37.304442;118.476187, 37.304231;118.476576, 37.304097;118.476955, 37.304053;118.477337, 37.304048;118.477847, 37.304137;118.479904, 37.304547;118.480324, 37.304581;118.480755, 37.304564;118.481123, 37.304551;118.482937, 37.304357;118.48338, 37.304321;118.483672, 37.30433;118.484004, 37.304407;118.484185, 37.30452;118.485002, 37.305037;118.48649, 37.306339;118.48707, 37.306617;118.487403, 37.306695;118.487924, 37.306735;118.488216, 37.306765;118.489456, 37.306682;118.491534, 37.306283;118.494738, 37.3059;118.497338, 37.305305;118.510246, 37.302642;118.51518, 37.301844;118.515682, 37.301838;118.515921, 37.301835;118.516263, 37.301911;118.516642, 37.302151;118.516969, 37.302546;118.517083, 37.302974;118.516908, 37.306852;118.516611, 37.310065;118.516659, 37.310393;118.516781, 37.310662;118.516978, 37.310949;118.517277, 37.311205;118.517597, 37.311401;118.51789, 37.311517;118.518233, 37.311634;118.518523, 37.311671;118.518799, 37.311668;118.520487, 37.311455;118.521889, 37.311193;118.522245, 37.311145;118.522395, 37.311144;118.522703, 37.311142;118.524745, 37.311225;118.525596, 37.311181;118.526275, 37.311218;118.52783, 37.311237;118.528982, 37.311183;118.529918, 37.311051;118.530277, 37.31093;118.530499, 37.31081;118.530645, 37.31067;118.530726, 37.310461;118.530862, 37.310022;118.530714, 37.307411;118.530818, 37.305218;118.530587, 37.302154;118.530592, 37.301527;118.530671, 37.301257;118.530738, 37.301017;118.530834, 37.300878;118.531004, 37.300708;118.531226, 37.300598;118.531537, 37.300518;118.532649, 37.300416;118.53537, 37.30048;118.540092, 37.300995;118.541421, 37.301013;118.543123, 37.300949;118.54597, 37.30057;118.547673, 37.300115;118.549062, 37.299425;118.550573, 37.298419;118.552074, 37.297054;118.553627, 37.295173;118.554979, 37.293048;118.555297, 37.292323;118.556843, 37.289732;118.557108, 37.289603;118.55782, 37.28965;118.558013, 37.291018;118.558245, 37.293851;118.558369, 37.294981;118.55836, 37.295566;118.558146, 37.296356;118.558027, 37.297125;118.558145, 37.297686;118.558281, 37.298018;118.558775, 37.298884;118.560186, 37.299819;118.560931, 37.300475;118.561187, 37.300811;118.561307, 37.301038;118.561358, 37.301257;118.561399, 37.302696;118.561253, 37.305052;118.561135, 37.305324;118.56108, 37.305375;118.560987, 37.30541;118.560925, 37.305422;118.56083, 37.305422;118.560199, 37.305358;118.559872, 37.305382;118.558796, 37.305556;118.556646, 37.305951;118.556346, 37.306033;118.556223, 37.3061;118.556169, 37.306175;118.55603, 37.30651;118.555867, 37.30732;118.556182, 37.309269;118.556295, 37.310415;118.556652, 37.313815;118.556903, 37.31761;118.557104, 37.317986;118.557435, 37.318511;118.557655, 37.318697;118.557974, 37.318842;118.558178, 37.31892;118.558442, 37.318927;118.558694, 37.318924;118.5616, 37.318197;118.562818, 37.317908;118.56293, 37.317851;118.56297, 37.31777;118.562531, 37.316267;118.562425, 37.313817;118.562197, 37.311509;118.5616, 37.308454;118.561553, 37.308185;118.561547, 37.307985;118.561554, 37.307816;118.561661, 37.307528;118.561815, 37.307246;118.562035, 37.307018;118.562238, 37.306896;118.562449, 37.306803;118.562674, 37.306739;118.56289, 37.306704;118.563081, 37.306775;118.563248, 37.306877;118.564938, 37.308441;118.568431, 37.311421;118.56877, 37.311723;118.568872, 37.311755;118.568999, 37.311792;118.569233, 37.311798;118.569777, 37.31182;118.569917, 37.311851;118.570026, 37.311923;118.570126, 37.312081;118.570189, 37.312274;118.570171, 37.313246;118.5698, 37.315786;118.568863, 37.319865;118.568828, 37.320558;118.569008, 37.321402;118.569221, 37.321725;118.569417, 37.32194;118.569675, 37.322104;118.569971, 37.322174;118.570679, 37.322192;118.571823, 37.322044;118.572555, 37.321836;118.572776, 37.321795;118.572952, 37.321785;118.573243, 37.321778;118.573536, 37.321855;118.573798, 37.321937;118.57403, 37.32205;118.57423, 37.32219;118.574412, 37.322348;118.574603, 37.322712;118.574605, 37.323996;118.574334, 37.325509;118.573749, 37.327326;118.573706, 37.327905;118.573763, 37.328113;118.573883, 37.328314;118.573997, 37.328476;118.574308, 37.328731;118.574547, 37.32886;118.575214, 37.329087;118.575717, 37.329148;118.576084, 37.329167;118.576356, 37.329159;118.576539, 37.329144;118.577336, 37.32897;118.5792, 37.328304;118.579746, 37.328143;118.580125, 37.328115;118.583285, 37.327972;118.584098, 37.32785;118.584947, 37.327641;118.585627, 37.327322;118.586429, 37.326814;118.58684, 37.326417;118.587195, 37.325675;118.587186, 37.325376;118.587002, 37.32328;118.586996, 37.321217;118.586958, 37.313389;118.587082, 37.312342;118.587244, 37.311887;118.587402, 37.311683;118.587598, 37.311476;118.587797, 37.311339;118.587983, 37.311223;118.588319, 37.31102;118.588607, 37.3109;118.588934, 37.310839;118.591434, 37.310844;118.594171, 37.310884;118.596512, 37.310704;118.597654,37.31079;118.597645,37.311465;118.597645,37.311465;118.597726,37.313783;118.597977,37.317083;118.598444,37.320448;118.599908,37.326869;118.601067,37.33382;118.601319,37.339351;118.601274,37.341531;118.601265,37.346466;118.601939,37.353236;118.602792,37.35723;118.604095,37.361655;118.605604,37.366466;118.606538,37.371435;118.606834,37.375787;118.606718,37.382741;118.607086,37.388769;118.607634,37.392561;118.608281,37.395665;118.609925,37.401556;118.610661,37.406436;118.610796,37.410292;118.61049,37.414219;118.609709,37.41927;118.608761,37.425529;118.608523,37.427925;118.608415,37.431862;118.608658,37.436031;118.608887,37.439165;118.608851,37.444634;118.608595,37.448033;118.607805,37.4532;118.607045,37.456416;118.605851,37.461529;118.605006,37.465521;118.604571,37.468775;118.604395,37.471389;118.604692,37.482658;118.604584,37.485761;118.604449,37.48734;118.604166,37.489237;118.604014,37.490207;118.603744,37.491524;118.603744,37.491524;118.60294,37.494788;118.602073,37.497458;118.600703,37.501459;118.599441,37.505302;118.598368,37.509947;118.597946,37.513414;118.597842,37.515249;118.597811,37.517382;118.59786,37.519017;118.594538, 37.519111;118.591991, 37.519135;118.587971, 37.519154;118.583149, 37.519246;118.578412, 37.519282;118.575624, 37.51927;118.568668, 37.519272;118.56708, 37.519267;118.559763, 37.519193;118.557327, 37.519219;118.553109, 37.519181;118.549825, 37.519129;118.548181, 37.519151;118.546513, 37.519114;118.546412, 37.519155;118.546375, 37.519179;118.546338, 37.519219;118.54626, 37.519329;118.546226, 37.519399;118.546166, 37.519499;118.545204, 37.521495;118.544885, 37.522073;118.54399, 37.522912;118.543943, 37.523011;118.543915, 37.523101;118.543937, 37.523205;118.543991, 37.52334;118.544127, 37.523458;118.544328, 37.523672;118.544813, 37.523887;118.545499, 37.523999;118.546572, 37.524059;118.547782, 37.524001;118.54863, 37.523858;118.549749, 37.523598;118.551643, 37.523014;118.551836, 37.522992;118.551937, 37.523002;118.552007, 37.523046;118.552059, 37.523105;118.552121, 37.523274;118.552049, 37.525665;118.551955, 37.526496;118.551762, 37.526906;118.55149, 37.527144;118.551288, 37.527265;118.550997, 37.527397;118.549433, 37.527869;118.549099, 37.528035;118.548945, 37.52811;118.548798, 37.528191;118.548619, 37.528312;118.547756, 37.529039;118.547546, 37.52913;118.547385, 37.52919;118.547172, 37.529201;118.546834, 37.529183;118.54662, 37.529154;118.545471, 37.528471;118.545293, 37.528393;118.545079, 37.528364;118.544853, 37.528365;118.54463, 37.528385;118.544418, 37.528426;118.544207, 37.528486;118.544048, 37.528606;118.543038, 37.529724;118.54285, 37.529928;118.542574, 37.530127;118.542169, 37.530338;118.541685, 37.530493;118.540412, 37.530687;118.538346, 37.5309;118.537503, 37.53114;118.537231, 37.531245;118.537046, 37.531326;118.536924, 37.53142;118.53682, 37.531509;118.536713, 37.531679;118.536554, 37.531988;118.536359, 37.533016;118.536363, 37.533136;118.53643, 37.533294;118.536984, 37.534687;118.537116, 37.535868;118.535942, 37.5368;118.534892, 37.536925;118.533678, 37.536501;118.531173, 37.533436;118.530785, 37.533186;118.53012, 37.533125;118.526972, 37.53444;118.523886, 37.536069;118.523546, 37.536205;118.522019, 37.536652;118.51771, 37.538041;118.51683, 37.538384;118.516084, 37.538796;118.514703, 37.539695;118.513161, 37.540765;118.512949, 37.540833;118.512743, 37.540881;118.512562, 37.540909;118.512361, 37.540917;118.511978, 37.540923;118.511546, 37.540887;118.510825, 37.540768;118.510074, 37.540677;118.50976, 37.540696;118.509591, 37.540705;118.509453, 37.540747;118.509273, 37.54082;118.508396, 37.541522;118.507828, 37.541754;118.507628, 37.541818;118.507253, 37.541895;118.50699, 37.54191;118.5067, 37.541916;118.506295, 37.541894;118.505864, 37.541804;118.505508, 37.541681;118.505022, 37.541463;118.504166, 37.540726;118.50312, 37.539575;118.502825, 37.539413;118.502685, 37.539416;118.502548, 37.539449;118.499946, 37.541486;118.499839, 37.541529;118.499676, 37.541558;118.499525, 37.541557;118.49924, 37.541525;118.498561, 37.541395;118.497919, 37.541099;118.497409, 37.540765;118.497271, 37.540615;118.497185, 37.540478;118.497174, 37.540314;118.497205, 37.538484;118.497168, 37.538107;118.497144, 37.537759;118.496895, 37.537109;118.496327, 37.53632;118.495536, 37.535523;118.494631, 37.534904;118.494247, 37.534756;118.494003, 37.534635;118.493569, 37.534539;118.491282, 37.534215;118.489767, 37.533918;118.488716, 37.533547;118.486728, 37.532567;118.485554, 37.531495;118.484863, 37.530516;118.484299, 37.529124;118.483622, 37.526775;118.483427, 37.523449;118.483252, 37.522321;118.482993, 37.521142;118.482345, 37.51932;118.482154, 37.51887;118.481865, 37.518553;118.481487, 37.518239;118.481099, 37.517985;118.480711, 37.517741;118.479942, 37.517472;118.479608, 37.517335;118.478193, 37.517081;118.477709, 37.51699;118.477363, 37.516895;118.477094, 37.516806;118.476862, 37.516695;118.476617, 37.516525;118.47642, 37.516334;118.476313, 37.516178;118.476204, 37.515924;118.476228, 37.515242;118.476324, 37.511264;118.476251, 37.510385;118.476127, 37.510037;118.475918, 37.509668;118.47533, 37.509098;118.474909, 37.508815;118.474659, 37.508696;118.474333, 37.508619;118.473944, 37.508559;118.473639, 37.508541;118.473189, 37.508558;118.472873, 37.50859;118.472527, 37.508663;118.472321, 37.508736;118.472096, 37.508834;118.471921, 37.508925;118.471792, 37.509059;118.471596, 37.509301;118.471536, 37.509582;118.471433, 37.510341;118.471372, 37.510525;118.470827, 37.511312;118.470746, 37.511365;118.470634, 37.511419;118.470458, 37.51148;118.466271, 37.511802;118.461745, 37.511989;118.461522, 37.511966;118.461337, 37.511918;118.461209, 37.511842;118.461101, 37.511638;118.46104, 37.511;118.460965, 37.510849;118.460808, 37.510665;118.460523, 37.510435;118.45993, 37.510091;118.459317, 37.509902;118.458592, 37.509795;118.458296, 37.509805;118.458088, 37.509851;118.457939, 37.509904;118.457814, 37.509974;118.456949, 37.510586;118.45678, 37.510656;118.456598, 37.510696;118.456459, 37.510701;118.456319, 37.510665;118.456114, 37.510576;118.455946, 37.510442;118.455769, 37.510238;118.455689, 37.510101;118.455633, 37.509923;118.455588, 37.509706;118.455599, 37.509447;118.455769, 37.508739;118.456041, 37.507944;118.456037, 37.50782;118.45602, 37.507686;118.45601, 37.507567;118.455956, 37.507459;118.455878, 37.507367;118.455793, 37.507285;118.455639, 37.50719;118.455414, 37.507087;118.453958, 37.506862;118.453275, 37.506721;118.452565, 37.506439;118.452239, 37.5059;118.451795, 37.50523;118.451672, 37.504812;118.451735, 37.504383;118.4522, 37.503331;118.452245, 37.503161;118.452227, 37.502992;118.452183, 37.502799;118.452147, 37.502651;118.452092, 37.502513;118.451987, 37.502371;118.451824, 37.502211;118.45056, 37.501633;118.447979, 37.500524;118.444981, 37.499015;118.443235, 37.497932;118.44231, 37.497321;118.441661, 37.496664;118.440223, 37.494914;118.439917, 37.493261;118.439891, 37.490399;118.440318, 37.489336;118.440525, 37.488726;118.440817, 37.488423;118.441814, 37.487751;118.442806, 37.487287;118.443668, 37.487074;118.446668, 37.486807;118.449084, 37.486696;118.452989, 37.486588;118.453215, 37.486571;118.453309, 37.486549;118.453414, 37.486486;118.454088, 37.485642;118.454147, 37.485491;118.454169, 37.485177;118.454485, 37.482228;118.455078, 37.479143;118.455104, 37.478978;118.455112, 37.478849;118.455107, 37.47869;118.455103, 37.478565;118.454338, 37.476785;118.454041, 37.47543;118.453462, 37.471758;118.453381, 37.471601;118.453328, 37.471523;118.453224, 37.471426;118.451506, 37.470604;118.451347, 37.470379;118.451291, 37.470221;118.451286, 37.470052;118.451503, 37.468768;118.451521, 37.468569;118.451529, 37.468399;118.450383, 37.46577;118.450048, 37.465365;118.449905, 37.465248;118.449739, 37.465183;118.446974, 37.464258;118.445581, 37.463291;118.445501, 37.463153;118.445485, 37.463023;118.445652, 37.45987;118.445605, 37.458846;118.445398, 37.457137;118.445312, 37.457014;118.440859, 37.454372;118.440727, 37.454195;118.440479, 37.452294;118.440425, 37.452181;118.440367, 37.452126;118.43908, 37.451132;118.438977, 37.451048;118.438975, 37.450989;118.438979, 37.450909;118.439489, 37.447998;118.439503, 37.447893;118.439501, 37.447803;118.439435, 37.447719;118.437822, 37.447163;118.437725, 37.447099;118.437698, 37.447025;118.437652, 37.445375;118.437672, 37.44522;118.438423, 37.443711;118.43852, 37.44361;118.438699, 37.443513;118.441896, 37.442287;118.444871, 37.440951;118.445418, 37.440742;118.445627, 37.440598;118.445737, 37.440496;118.446355, 37.438613;118.446363, 37.438463;118.446358, 37.438324;118.444416, 37.432711;118.444399, 37.432572;118.44442, 37.432432;118.444711, 37.432109;118.447609, 37.430158;118.448558, 37.429057;118.448012, 37.427914;118.445945, 37.423989;118.44465, 37.42326;118.444585, 37.42323;118.444491, 37.423275;118.444092, 37.42353;118.440321, 37.426153;118.438557, 37.427754;118.433579, 37.429044;118.431553, 37.430712;118.431508, 37.430793;118.431473, 37.430913;118.431662, 37.432711;118.431592, 37.432756;118.43149, 37.432781;118.425686, 37.432828;118.425433, 37.432829;118.425236, 37.432842;118.424921, 37.432894;118.423863, 37.433142;118.423456, 37.433212;118.421873, 37.433226;118.421756, 37.433302;118.421342, 37.434859;118.420263, 37.437452;118.420179, 37.437553;118.420102, 37.437598;118.419936, 37.437597;118.4171, 37.437694;118.416365, 37.437644;118.415943, 37.437526;118.415791, 37.437469;118.415708, 37.437351;118.415663, 37.437187;118.415654, 37.435833;118.415577, 37.433975;118.415426, 37.433698;118.415281, 37.433593;118.414497, 37.43328;118.414282, 37.433224;118.411961, 37.433215;118.411828, 37.433254;118.411687, 37.43331;118.410419, 37.434265;118.410295, 37.434316;118.407241, 37.435;118.403287, 37.435898;118.399944, 37.436198;118.399269, 37.43638;118.398988, 37.436508;118.398762, 37.436824;118.398627, 37.437076;118.398541, 37.437329;118.398518, 37.437592;118.398668, 37.439519;118.398632, 37.439846;118.397987, 37.441385;118.396964, 37.442551;118.39681, 37.442665;118.396558, 37.442743;118.393844, 37.443065;118.393671, 37.443063;118.393588, 37.442969;118.393108, 37.441877;118.391856, 37.439132;118.390532, 37.43627;118.390251, 37.435685;118.389745, 37.435537;118.389049, 37.435535;118.386624, 37.4357;118.386495, 37.43564;118.38642, 37.435535;118.386177, 37.434293;118.385914, 37.433337;118.385763, 37.433102;118.385639, 37.432973;118.385518, 37.4329;118.385358, 37.43286;118.385094, 37.432827;118.383211, 37.432839;118.376615, 37.432928;118.373388, 37.432996;118.373188, 37.432984;118.372955, 37.432948;118.372628, 37.432798;118.3724, 37.432667;118.372201, 37.43246;118.372097, 37.4322;118.372052, 37.431787;118.372352, 37.429058;118.372608, 37.427128;118.37255, 37.426841;118.372332, 37.426522;118.369783, 37.424736;118.368303, 37.424637;118.364896, 37.424339;118.361012, 37.424108;118.357671, 37.424265;118.357352, 37.424289;118.357034, 37.424358;118.354784, 37.425022;118.354625, 37.425029;118.354417, 37.425024;118.354176, 37.424995;118.353525, 37.424882;118.349984, 37.424781;118.346041, 37.424719;118.345597, 37.424603;118.345346, 37.424487;118.344046, 37.423431;118.342514, 37.421788;118.342377, 37.421742;118.342081, 37.421708;118.339438, 37.421664;118.339224, 37.421695;118.339073, 37.421744;118.337475, 37.422393;118.33503, 37.423294;118.33264, 37.423947;118.329124, 37.424699;118.326849, 37.425175;118.325726, 37.425271;118.323409, 37.425314;118.316601, 37.425546;118.307482, 37.434521;118.306116, 37.435678;118.304271, 37.435883;118.30404, 37.437807;118.303951, 37.437983;118.303768, 37.438172;118.303194, 37.438469;118.302432, 37.438873;118.300992, 37.439363;118.300916, 37.439439;118.300857, 37.439577;118.300639, 37.440968;118.300548, 37.441113;118.30041, 37.441245;118.300256, 37.441352;118.299719, 37.44158;118.299461, 37.441668;118.299303, 37.441668;118.299098, 37.441656;118.297359, 37.441376;118.297139, 37.441364;118.296903, 37.441408;118.294925, 37.442014;118.292633, 37.443215;118.292611, 37.443297;118.292893, 37.445595;118.292864, 37.445682;118.292794, 37.445714;118.292715, 37.445727;118.29145, 37.445539;118.291242, 37.445476;118.291088, 37.445344;118.29098, 37.445187;118.290502, 37.444089;118.290397, 37.443995;118.288303, 37.443506;118.288083, 37.443532;118.284769, 37.44451;118.284613, 37.44458;118.28452, 37.444649;118.284078, 37.445368;118.284037, 37.445581;118.284064, 37.445663;118.285233, 37.446706;118.285251, 37.446768;118.285246, 37.446859;118.285002, 37.448046;118.284851, 37.448131;118.278286, 37.44994;118.278147, 37.450023;118.278078, 37.450087;118.278035, 37.450237;118.27794, 37.451026;118.277743, 37.452478;118.277628, 37.453088;118.277023, 37.454316;118.276189, 37.455908;118.275565, 37.456798;118.275434, 37.456906;118.275317, 37.456983;118.275178, 37.45706;118.27506, 37.457105;118.274863, 37.457139;118.274451, 37.457138;118.272518, 37.457057;118.272399, 37.457059;118.272284, 37.45707;118.272096, 37.457126;118.270592, 37.457718;118.270455, 37.457787;118.270267, 37.458011;118.268585, 37.459962;118.267662, 37.461122;118.266967, 37.461629;118.266084, 37.462287;118.265935, 37.462347;118.265736, 37.462363;118.265131, 37.462326;118.264841, 37.462232;118.264655, 37.462136;118.264426, 37.461934;118.263869, 37.461302;118.26322, 37.460175;118.263058, 37.459877;118.262824, 37.459763;118.261324, 37.459637;118.259766, 37.45996;118.252795, 37.445574;118.248431, 37.43514;118.246407, 37.430942;118.244205, 37.425735;118.243711, 37.423342;118.243638, 37.422089;118.24376, 37.419718;118.244223, 37.41528;118.245809, 37.410413;118.247282, 37.40353;118.247672, 37.401206;118.247595, 37.399765;118.247188, 37.398512;118.246392, 37.397637;118.244384, 37.396267;118.242108, 37.395097;118.238236, 37.393732;118.231548, 37.392658;118.221952, 37.391765",
    //   ];
    //   var count = boundariesValue.length; // 行政区域的点有多少个
    //   console.log(count)
    //   if (count == 0) {
    //     alert("未能获取当前输入行政区域");
    //     return;
    //   }
    //   for (var i = 0; i < count; i++) {
    //     var ply = new BMap.Polygon(boundariesValue[i], {
    //       strokeWeight: 2.9, //设置多边形边线线粗
    //       strokeOpacity: 1, //设置多边形边线透明度0-1
    //       strokeStyle: "dashed", //设置多边形边线样式为实线或虚线，取值 solid 或 dashed
    //       strokeColor: "#0099FF", //设置多边形边线颜色
    //       fillOpacity: 0.1, //设置多边形填充颜色透明度0-1
    //     });
    //     console.log(ply)
    //     map.addOverlay(ply); //添加覆盖物
    //   }
    //   map.setZoom(10);
    // },

    // // 地图添加黑色透明度遮罩层
    // addMask({ BMap, map }) {
    //   // 地图经纬度
    //   let boundariesValue = {
    //     boundaries: [
    //       "118.221952, 37.391765;118.2225, 37.391591;118.223152, 37.391392;118.223567, 37.390599;118.224389, 37.386527;118.224794, 37.382918;118.224784, 37.379937;118.224702, 37.379028;118.224753, 37.378613;118.224909, 37.378362;118.225378, 37.378043;118.226005, 37.377845;118.228095, 37.377535;118.229191, 37.3771;118.229451, 37.376784;118.229657, 37.376159;118.229627, 37.375;118.229782, 37.374355;118.230094, 37.374018;118.230774, 37.373735;118.231349, 37.373702;118.231819, 37.373775;118.232761, 37.373983;118.237473, 37.37527;118.238833, 37.375427;118.239304, 37.375439;118.239775, 37.375428;118.240716, 37.375181;118.241967, 37.374306;118.243063, 37.373683;118.243977, 37.373333;118.245256, 37.37306;118.247138, 37.373024;118.249124, 37.373237;118.250876, 37.373683;118.25289, 37.374769;118.253832, 37.375543;118.253938, 37.376141;118.253968, 37.377238;118.253481, 37.379708;118.253016, 37.381165;118.252967, 37.381807;118.253072, 37.382054;118.253516, 37.382337;118.253829, 37.382395;118.254456, 37.382386;118.254977, 37.382316;118.255708, 37.382306;118.256203, 37.382446;118.256935, 37.382789;118.257379, 37.383053;118.258295, 37.384119;118.258765, 37.384466;118.25934, 37.384874;118.260253, 37.385466;118.261139, 37.385707;118.262286, 37.38578;118.263248, 37.385692;118.264184, 37.38521;118.265245, 37.384005;118.266539, 37.381867;118.267285, 37.379712;118.267897, 37.376358;118.268095, 37.373501;118.268452, 37.371699;118.268839, 37.370953;118.269304, 37.370166;118.270235, 37.369255;118.271867, 37.368326;118.27451, 37.3673;118.277178, 37.366694;118.278809, 37.366499;118.280311, 37.366533;118.281659, 37.366836;118.283369, 37.367289;118.285415, 37.36777;118.288185, 37.368304;118.290641, 37.368505;118.292372, 37.368324;118.293353, 37.367822;118.29518, 37.36578;118.296467, 37.364288;118.296826, 37.363776;118.296954, 37.363406;118.296848, 37.362846;118.295915, 37.362188;118.294774, 37.361218;118.294099, 37.360421;118.293992, 37.359488;118.29404, 37.358888;118.294143, 37.35862;118.294426, 37.358355;118.294942, 37.358178;118.295975, 37.358007;118.297603, 37.357846;118.301866, 37.357561;118.308565, 37.35788;118.313535, 37.358015;118.319291, 37.358238;118.320666, 37.358285;118.321599, 37.358018;118.321935, 37.357666;118.322141, 37.357314;118.32227, 37.356983;118.322268, 37.356507;118.322187, 37.355844;118.32183, 37.351495;118.32151, 37.344473;118.321429, 37.338819;118.321277, 37.334593;118.321051, 37.331029;118.321658, 37.328131;118.322539, 37.322933;118.323758, 37.317713;118.324367, 37.315124;118.324802, 37.313756;118.325162, 37.313175;118.325525, 37.312947;118.326252, 37.312758;118.326798, 37.312757;118.3288, 37.312748;118.330206, 37.312678;118.331116, 37.312485;118.332232, 37.311979;118.332906, 37.311207;118.333316, 37.309939;118.333621, 37.308218;118.333588, 37.307017;118.33332, 37.30559;118.333289, 37.304534;118.333262, 37.304183;118.333493, 37.303517;118.33383, 37.303017;118.334814, 37.301847;118.335879, 37.301151;118.336843, 37.300767;118.337546, 37.300675;118.339164, 37.300633;118.342924, 37.300904;118.344961, 37.300869;118.346059, 37.300848;118.347103, 37.300726;118.348017, 37.300418;118.348981, 37.299943;118.349684, 37.299349;118.350257, 37.298985;118.350519, 37.298876;118.350962, 37.298826;118.351564, 37.298814;118.352898, 37.298889;118.353657, 37.298935;118.354049, 37.298927;118.354283, 37.29884;118.354779, 37.298621;118.354884, 37.298412;118.354906, 37.297708;118.354669, 37.29736;118.353908, 37.296734;118.353175, 37.296585;118.352522, 37.296599;118.351111, 37.29698;118.350537, 37.297033;118.350091, 37.297001;118.349751, 37.296863;118.349043, 37.296297;118.348936, 37.295761;118.348984, 37.294766;118.349581, 37.293657;118.35031, 37.293144;118.351094, 37.292983;118.351773, 37.292928;118.353943, 37.292862;118.356062, 37.292817;118.358521, 37.293012;118.359775, 37.292986;118.360846, 37.292757;118.362466, 37.292392;118.363589, 37.291955;118.364162, 37.291509;118.364395, 37.291007;118.364472, 37.290612;118.36447, 37.290198;118.364572, 37.28945;118.364648, 37.289035;118.364905, 37.288036;118.366127, 37.286377;118.367118, 37.285799;118.367979, 37.285369;118.36884, 37.285167;118.369832, 37.28515;118.372887, 37.285308;118.374531, 37.285263;118.375077, 37.284904;118.375337, 37.28457;118.375413, 37.284299;118.375464, 37.283656;118.375409, 37.283078;118.375251, 37.282707;118.374674, 37.281949;118.374073, 37.281398;118.373706, 37.281321;118.373445, 37.281324;118.373081, 37.281392;118.37183, 37.28195;118.370945, 37.28244;118.370631, 37.282528;118.370318, 37.282533;118.370031, 37.282496;118.369716, 37.282337;118.369455, 37.282051;118.369349, 37.281784;118.369191, 37.281413;118.369137, 37.280897;118.36924, 37.280419;118.370177, 37.279907;118.371299, 37.279597;118.372238, 37.279438;118.373804, 37.279497;118.37558, 37.279784;118.3767, 37.279749;118.377612, 37.27949;118.378184, 37.279028;118.37987, 37.276899;118.381189, 37.274404;118.381805, 37.271832;118.382501, 37.267907;118.382587, 37.267427;118.386132, 37.267461;118.391709, 37.267222;118.39446, 37.267207;118.395146, 37.267404;118.39616, 37.267868;118.396675, 37.268607;118.396897, 37.269282;118.397078, 37.273086;118.397609, 37.276991;118.397832, 37.277773;118.397956, 37.277936;118.398078, 37.27802;118.398243, 37.278068;118.398419, 37.278106;118.398596, 37.278104;118.398828, 37.278103;118.399084, 37.278065;118.400286, 37.277731;118.401154, 37.27756;118.401966, 37.27748;118.402437, 37.277476;118.403041, 37.277604;118.403454, 37.277776;118.403666, 37.277934;118.403912, 37.278187;118.404069, 37.278386;118.404146, 37.278649;118.404256, 37.278963;118.404239, 37.27941;118.404108, 37.279845;118.403625, 37.280864;118.403486, 37.281602;118.403653, 37.282149;118.403787, 37.282407;118.404058, 37.282655;118.404328, 37.282833;118.40476, 37.283;118.405138, 37.283077;118.405515, 37.283096;118.407379, 37.282928;118.40768, 37.282957;118.407921, 37.283036;118.408295, 37.283354;118.408606, 37.28411;118.408858, 37.285938;118.409167, 37.287351;118.409376, 37.28763;118.409567, 37.287759;118.409909, 37.287857;118.410162, 37.287916;118.410639, 37.287945;118.412944, 37.287911;118.413121, 37.28797;118.413288, 37.288079;118.413446, 37.288318;118.413528, 37.288517;118.413571, 37.288736;118.413474, 37.28902;118.412948, 37.289809;118.411843, 37.290926;118.411358, 37.291844;118.411227, 37.292821;118.411346, 37.293827;118.411786, 37.295062;118.412589, 37.296421;118.413495, 37.297355;118.414224, 37.297803;118.414988, 37.29818;118.415368, 37.298279;118.415895, 37.298298;118.416132, 37.298297;118.416319, 37.298257;118.416452, 37.298127;118.416521, 37.297919;118.41659, 37.297739;118.416569, 37.297091;118.416503, 37.295688;118.416519, 37.295589;118.416547, 37.295509;118.416711, 37.295344;118.416847, 37.29528;118.417681, 37.295108;118.418104, 37.295048;118.418331, 37.295052;118.418538, 37.295082;118.418672, 37.295157;118.418809, 37.295316;118.419314, 37.29683;118.420679, 37.299508;118.421418, 37.301041;118.421767, 37.301389;118.421973, 37.301538;118.427741, 37.304473;118.428324, 37.304659;118.428817, 37.304766;118.429017, 37.304765;118.429229, 37.304724;118.429365, 37.304643;118.429435, 37.304493;118.429464, 37.304225;118.42937, 37.303637;118.428968, 37.302852;118.427949, 37.301592;118.427697, 37.30098;118.427618, 37.300502;118.427647, 37.300203;118.427738, 37.299913;118.427894, 37.299704;118.428016, 37.299594;118.428152, 37.299513;118.428436, 37.299402;118.428786, 37.29933;118.429475, 37.299327;118.42996, 37.299562;118.430385, 37.299908;118.430519, 37.300177;118.43059, 37.300405;118.430667, 37.300893;118.430802, 37.301151;118.430918, 37.301271;118.43111, 37.301358;118.431351, 37.301447;118.431667, 37.301515;118.431969, 37.301532;118.432555, 37.301408;118.433828, 37.301138;118.434204, 37.301114;118.434568, 37.301111;118.434986, 37.301207;118.435521, 37.301563;118.435873, 37.301953;118.436087, 37.302519;118.437217, 37.30577;118.437352, 37.306048;118.437494, 37.306165;118.43771, 37.306223;118.438038, 37.306269;118.44188, 37.306364;118.443825, 37.306511;118.446454, 37.306934;118.449578, 37.307533;118.45166, 37.308066;118.452041, 37.308136;118.452269, 37.308141;118.452471, 37.308135;118.452633, 37.308081;118.45277, 37.307998;118.452892, 37.307865;118.452964, 37.307753;118.453044, 37.307482;118.453023, 37.307224;118.4525, 37.305952;118.451385, 37.303918;118.449313, 37.301351;118.448658, 37.30023;118.448533, 37.299495;118.448497, 37.29906;118.448544, 37.298765;118.448748, 37.298237;118.449107, 37.297831;118.449374, 37.297593;118.449679, 37.297461;118.449855, 37.297426;118.450081, 37.297407;118.450979, 37.297435;118.453715, 37.297458;118.457262, 37.297504;118.458237, 37.297519;118.458369, 37.297515;118.458478, 37.297536;118.458625, 37.297592;118.458793, 37.297681;118.459008, 37.297864;118.459185, 37.298078;118.459351, 37.298306;118.459457, 37.298656;118.459552, 37.299012;118.460446, 37.301488;118.461139, 37.302929;118.462418, 37.306763;118.462869, 37.308153;118.463071, 37.308526;118.463244, 37.308748;118.463557, 37.309057;118.463947, 37.309322;118.464219, 37.309482;118.464525, 37.309572;118.464805, 37.309601;118.465313, 37.309604;118.468308, 37.309479;118.472579, 37.309717;118.474955, 37.309786;118.475447, 37.309697;118.475762, 37.309625;118.476237, 37.309387;118.476497, 37.309228;118.476644, 37.309032;118.476884, 37.308645;118.476953, 37.308393;118.476936, 37.30809;118.475524, 37.306061;118.475483, 37.305604;118.475473, 37.305295;118.475538, 37.304964;118.475768, 37.304597;118.475902, 37.304442;118.476187, 37.304231;118.476576, 37.304097;118.476955, 37.304053;118.477337, 37.304048;118.477847, 37.304137;118.479904, 37.304547;118.480324, 37.304581;118.480755, 37.304564;118.481123, 37.304551;118.482937, 37.304357;118.48338, 37.304321;118.483672, 37.30433;118.484004, 37.304407;118.484185, 37.30452;118.485002, 37.305037;118.48649, 37.306339;118.48707, 37.306617;118.487403, 37.306695;118.487924, 37.306735;118.488216, 37.306765;118.489456, 37.306682;118.491534, 37.306283;118.494738, 37.3059;118.497338, 37.305305;118.510246, 37.302642;118.51518, 37.301844;118.515682, 37.301838;118.515921, 37.301835;118.516263, 37.301911;118.516642, 37.302151;118.516969, 37.302546;118.517083, 37.302974;118.516908, 37.306852;118.516611, 37.310065;118.516659, 37.310393;118.516781, 37.310662;118.516978, 37.310949;118.517277, 37.311205;118.517597, 37.311401;118.51789, 37.311517;118.518233, 37.311634;118.518523, 37.311671;118.518799, 37.311668;118.520487, 37.311455;118.521889, 37.311193;118.522245, 37.311145;118.522395, 37.311144;118.522703, 37.311142;118.524745, 37.311225;118.525596, 37.311181;118.526275, 37.311218;118.52783, 37.311237;118.528982, 37.311183;118.529918, 37.311051;118.530277, 37.31093;118.530499, 37.31081;118.530645, 37.31067;118.530726, 37.310461;118.530862, 37.310022;118.530714, 37.307411;118.530818, 37.305218;118.530587, 37.302154;118.530592, 37.301527;118.530671, 37.301257;118.530738, 37.301017;118.530834, 37.300878;118.531004, 37.300708;118.531226, 37.300598;118.531537, 37.300518;118.532649, 37.300416;118.53537, 37.30048;118.540092, 37.300995;118.541421, 37.301013;118.543123, 37.300949;118.54597, 37.30057;118.547673, 37.300115;118.549062, 37.299425;118.550573, 37.298419;118.552074, 37.297054;118.553627, 37.295173;118.554979, 37.293048;118.555297, 37.292323;118.556843, 37.289732;118.557108, 37.289603;118.55782, 37.28965;118.558013, 37.291018;118.558245, 37.293851;118.558369, 37.294981;118.55836, 37.295566;118.558146, 37.296356;118.558027, 37.297125;118.558145, 37.297686;118.558281, 37.298018;118.558775, 37.298884;118.560186, 37.299819;118.560931, 37.300475;118.561187, 37.300811;118.561307, 37.301038;118.561358, 37.301257;118.561399, 37.302696;118.561253, 37.305052;118.561135, 37.305324;118.56108, 37.305375;118.560987, 37.30541;118.560925, 37.305422;118.56083, 37.305422;118.560199, 37.305358;118.559872, 37.305382;118.558796, 37.305556;118.556646, 37.305951;118.556346, 37.306033;118.556223, 37.3061;118.556169, 37.306175;118.55603, 37.30651;118.555867, 37.30732;118.556182, 37.309269;118.556295, 37.310415;118.556652, 37.313815;118.556903, 37.31761;118.557104, 37.317986;118.557435, 37.318511;118.557655, 37.318697;118.557974, 37.318842;118.558178, 37.31892;118.558442, 37.318927;118.558694, 37.318924;118.5616, 37.318197;118.562818, 37.317908;118.56293, 37.317851;118.56297, 37.31777;118.562531, 37.316267;118.562425, 37.313817;118.562197, 37.311509;118.5616, 37.308454;118.561553, 37.308185;118.561547, 37.307985;118.561554, 37.307816;118.561661, 37.307528;118.561815, 37.307246;118.562035, 37.307018;118.562238, 37.306896;118.562449, 37.306803;118.562674, 37.306739;118.56289, 37.306704;118.563081, 37.306775;118.563248, 37.306877;118.564938, 37.308441;118.568431, 37.311421;118.56877, 37.311723;118.568872, 37.311755;118.568999, 37.311792;118.569233, 37.311798;118.569777, 37.31182;118.569917, 37.311851;118.570026, 37.311923;118.570126, 37.312081;118.570189, 37.312274;118.570171, 37.313246;118.5698, 37.315786;118.568863, 37.319865;118.568828, 37.320558;118.569008, 37.321402;118.569221, 37.321725;118.569417, 37.32194;118.569675, 37.322104;118.569971, 37.322174;118.570679, 37.322192;118.571823, 37.322044;118.572555, 37.321836;118.572776, 37.321795;118.572952, 37.321785;118.573243, 37.321778;118.573536, 37.321855;118.573798, 37.321937;118.57403, 37.32205;118.57423, 37.32219;118.574412, 37.322348;118.574603, 37.322712;118.574605, 37.323996;118.574334, 37.325509;118.573749, 37.327326;118.573706, 37.327905;118.573763, 37.328113;118.573883, 37.328314;118.573997, 37.328476;118.574308, 37.328731;118.574547, 37.32886;118.575214, 37.329087;118.575717, 37.329148;118.576084, 37.329167;118.576356, 37.329159;118.576539, 37.329144;118.577336, 37.32897;118.5792, 37.328304;118.579746, 37.328143;118.580125, 37.328115;118.583285, 37.327972;118.584098, 37.32785;118.584947, 37.327641;118.585627, 37.327322;118.586429, 37.326814;118.58684, 37.326417;118.587195, 37.325675;118.587186, 37.325376;118.587002, 37.32328;118.586996, 37.321217;118.586958, 37.313389;118.587082, 37.312342;118.587244, 37.311887;118.587402, 37.311683;118.587598, 37.311476;118.587797, 37.311339;118.587983, 37.311223;118.588319, 37.31102;118.588607, 37.3109;118.588934, 37.310839;118.591434, 37.310844;118.594171, 37.310884;118.596512, 37.310704;118.597654,37.31079;118.597645,37.311465;118.597645,37.311465;118.597726,37.313783;118.597977,37.317083;118.598444,37.320448;118.599908,37.326869;118.601067,37.33382;118.601319,37.339351;118.601274,37.341531;118.601265,37.346466;118.601939,37.353236;118.602792,37.35723;118.604095,37.361655;118.605604,37.366466;118.606538,37.371435;118.606834,37.375787;118.606718,37.382741;118.607086,37.388769;118.607634,37.392561;118.608281,37.395665;118.609925,37.401556;118.610661,37.406436;118.610796,37.410292;118.61049,37.414219;118.609709,37.41927;118.608761,37.425529;118.608523,37.427925;118.608415,37.431862;118.608658,37.436031;118.608887,37.439165;118.608851,37.444634;118.608595,37.448033;118.607805,37.4532;118.607045,37.456416;118.605851,37.461529;118.605006,37.465521;118.604571,37.468775;118.604395,37.471389;118.604692,37.482658;118.604584,37.485761;118.604449,37.48734;118.604166,37.489237;118.604014,37.490207;118.603744,37.491524;118.603744,37.491524;118.60294,37.494788;118.602073,37.497458;118.600703,37.501459;118.599441,37.505302;118.598368,37.509947;118.597946,37.513414;118.597842,37.515249;118.597811,37.517382;118.59786,37.519017;118.594538, 37.519111;118.591991, 37.519135;118.587971, 37.519154;118.583149, 37.519246;118.578412, 37.519282;118.575624, 37.51927;118.568668, 37.519272;118.56708, 37.519267;118.559763, 37.519193;118.557327, 37.519219;118.553109, 37.519181;118.549825, 37.519129;118.548181, 37.519151;118.546513, 37.519114;118.546412, 37.519155;118.546375, 37.519179;118.546338, 37.519219;118.54626, 37.519329;118.546226, 37.519399;118.546166, 37.519499;118.545204, 37.521495;118.544885, 37.522073;118.54399, 37.522912;118.543943, 37.523011;118.543915, 37.523101;118.543937, 37.523205;118.543991, 37.52334;118.544127, 37.523458;118.544328, 37.523672;118.544813, 37.523887;118.545499, 37.523999;118.546572, 37.524059;118.547782, 37.524001;118.54863, 37.523858;118.549749, 37.523598;118.551643, 37.523014;118.551836, 37.522992;118.551937, 37.523002;118.552007, 37.523046;118.552059, 37.523105;118.552121, 37.523274;118.552049, 37.525665;118.551955, 37.526496;118.551762, 37.526906;118.55149, 37.527144;118.551288, 37.527265;118.550997, 37.527397;118.549433, 37.527869;118.549099, 37.528035;118.548945, 37.52811;118.548798, 37.528191;118.548619, 37.528312;118.547756, 37.529039;118.547546, 37.52913;118.547385, 37.52919;118.547172, 37.529201;118.546834, 37.529183;118.54662, 37.529154;118.545471, 37.528471;118.545293, 37.528393;118.545079, 37.528364;118.544853, 37.528365;118.54463, 37.528385;118.544418, 37.528426;118.544207, 37.528486;118.544048, 37.528606;118.543038, 37.529724;118.54285, 37.529928;118.542574, 37.530127;118.542169, 37.530338;118.541685, 37.530493;118.540412, 37.530687;118.538346, 37.5309;118.537503, 37.53114;118.537231, 37.531245;118.537046, 37.531326;118.536924, 37.53142;118.53682, 37.531509;118.536713, 37.531679;118.536554, 37.531988;118.536359, 37.533016;118.536363, 37.533136;118.53643, 37.533294;118.536984, 37.534687;118.537116, 37.535868;118.535942, 37.5368;118.534892, 37.536925;118.533678, 37.536501;118.531173, 37.533436;118.530785, 37.533186;118.53012, 37.533125;118.526972, 37.53444;118.523886, 37.536069;118.523546, 37.536205;118.522019, 37.536652;118.51771, 37.538041;118.51683, 37.538384;118.516084, 37.538796;118.514703, 37.539695;118.513161, 37.540765;118.512949, 37.540833;118.512743, 37.540881;118.512562, 37.540909;118.512361, 37.540917;118.511978, 37.540923;118.511546, 37.540887;118.510825, 37.540768;118.510074, 37.540677;118.50976, 37.540696;118.509591, 37.540705;118.509453, 37.540747;118.509273, 37.54082;118.508396, 37.541522;118.507828, 37.541754;118.507628, 37.541818;118.507253, 37.541895;118.50699, 37.54191;118.5067, 37.541916;118.506295, 37.541894;118.505864, 37.541804;118.505508, 37.541681;118.505022, 37.541463;118.504166, 37.540726;118.50312, 37.539575;118.502825, 37.539413;118.502685, 37.539416;118.502548, 37.539449;118.499946, 37.541486;118.499839, 37.541529;118.499676, 37.541558;118.499525, 37.541557;118.49924, 37.541525;118.498561, 37.541395;118.497919, 37.541099;118.497409, 37.540765;118.497271, 37.540615;118.497185, 37.540478;118.497174, 37.540314;118.497205, 37.538484;118.497168, 37.538107;118.497144, 37.537759;118.496895, 37.537109;118.496327, 37.53632;118.495536, 37.535523;118.494631, 37.534904;118.494247, 37.534756;118.494003, 37.534635;118.493569, 37.534539;118.491282, 37.534215;118.489767, 37.533918;118.488716, 37.533547;118.486728, 37.532567;118.485554, 37.531495;118.484863, 37.530516;118.484299, 37.529124;118.483622, 37.526775;118.483427, 37.523449;118.483252, 37.522321;118.482993, 37.521142;118.482345, 37.51932;118.482154, 37.51887;118.481865, 37.518553;118.481487, 37.518239;118.481099, 37.517985;118.480711, 37.517741;118.479942, 37.517472;118.479608, 37.517335;118.478193, 37.517081;118.477709, 37.51699;118.477363, 37.516895;118.477094, 37.516806;118.476862, 37.516695;118.476617, 37.516525;118.47642, 37.516334;118.476313, 37.516178;118.476204, 37.515924;118.476228, 37.515242;118.476324, 37.511264;118.476251, 37.510385;118.476127, 37.510037;118.475918, 37.509668;118.47533, 37.509098;118.474909, 37.508815;118.474659, 37.508696;118.474333, 37.508619;118.473944, 37.508559;118.473639, 37.508541;118.473189, 37.508558;118.472873, 37.50859;118.472527, 37.508663;118.472321, 37.508736;118.472096, 37.508834;118.471921, 37.508925;118.471792, 37.509059;118.471596, 37.509301;118.471536, 37.509582;118.471433, 37.510341;118.471372, 37.510525;118.470827, 37.511312;118.470746, 37.511365;118.470634, 37.511419;118.470458, 37.51148;118.466271, 37.511802;118.461745, 37.511989;118.461522, 37.511966;118.461337, 37.511918;118.461209, 37.511842;118.461101, 37.511638;118.46104, 37.511;118.460965, 37.510849;118.460808, 37.510665;118.460523, 37.510435;118.45993, 37.510091;118.459317, 37.509902;118.458592, 37.509795;118.458296, 37.509805;118.458088, 37.509851;118.457939, 37.509904;118.457814, 37.509974;118.456949, 37.510586;118.45678, 37.510656;118.456598, 37.510696;118.456459, 37.510701;118.456319, 37.510665;118.456114, 37.510576;118.455946, 37.510442;118.455769, 37.510238;118.455689, 37.510101;118.455633, 37.509923;118.455588, 37.509706;118.455599, 37.509447;118.455769, 37.508739;118.456041, 37.507944;118.456037, 37.50782;118.45602, 37.507686;118.45601, 37.507567;118.455956, 37.507459;118.455878, 37.507367;118.455793, 37.507285;118.455639, 37.50719;118.455414, 37.507087;118.453958, 37.506862;118.453275, 37.506721;118.452565, 37.506439;118.452239, 37.5059;118.451795, 37.50523;118.451672, 37.504812;118.451735, 37.504383;118.4522, 37.503331;118.452245, 37.503161;118.452227, 37.502992;118.452183, 37.502799;118.452147, 37.502651;118.452092, 37.502513;118.451987, 37.502371;118.451824, 37.502211;118.45056, 37.501633;118.447979, 37.500524;118.444981, 37.499015;118.443235, 37.497932;118.44231, 37.497321;118.441661, 37.496664;118.440223, 37.494914;118.439917, 37.493261;118.439891, 37.490399;118.440318, 37.489336;118.440525, 37.488726;118.440817, 37.488423;118.441814, 37.487751;118.442806, 37.487287;118.443668, 37.487074;118.446668, 37.486807;118.449084, 37.486696;118.452989, 37.486588;118.453215, 37.486571;118.453309, 37.486549;118.453414, 37.486486;118.454088, 37.485642;118.454147, 37.485491;118.454169, 37.485177;118.454485, 37.482228;118.455078, 37.479143;118.455104, 37.478978;118.455112, 37.478849;118.455107, 37.47869;118.455103, 37.478565;118.454338, 37.476785;118.454041, 37.47543;118.453462, 37.471758;118.453381, 37.471601;118.453328, 37.471523;118.453224, 37.471426;118.451506, 37.470604;118.451347, 37.470379;118.451291, 37.470221;118.451286, 37.470052;118.451503, 37.468768;118.451521, 37.468569;118.451529, 37.468399;118.450383, 37.46577;118.450048, 37.465365;118.449905, 37.465248;118.449739, 37.465183;118.446974, 37.464258;118.445581, 37.463291;118.445501, 37.463153;118.445485, 37.463023;118.445652, 37.45987;118.445605, 37.458846;118.445398, 37.457137;118.445312, 37.457014;118.440859, 37.454372;118.440727, 37.454195;118.440479, 37.452294;118.440425, 37.452181;118.440367, 37.452126;118.43908, 37.451132;118.438977, 37.451048;118.438975, 37.450989;118.438979, 37.450909;118.439489, 37.447998;118.439503, 37.447893;118.439501, 37.447803;118.439435, 37.447719;118.437822, 37.447163;118.437725, 37.447099;118.437698, 37.447025;118.437652, 37.445375;118.437672, 37.44522;118.438423, 37.443711;118.43852, 37.44361;118.438699, 37.443513;118.441896, 37.442287;118.444871, 37.440951;118.445418, 37.440742;118.445627, 37.440598;118.445737, 37.440496;118.446355, 37.438613;118.446363, 37.438463;118.446358, 37.438324;118.444416, 37.432711;118.444399, 37.432572;118.44442, 37.432432;118.444711, 37.432109;118.447609, 37.430158;118.448558, 37.429057;118.448012, 37.427914;118.445945, 37.423989;118.44465, 37.42326;118.444585, 37.42323;118.444491, 37.423275;118.444092, 37.42353;118.440321, 37.426153;118.438557, 37.427754;118.433579, 37.429044;118.431553, 37.430712;118.431508, 37.430793;118.431473, 37.430913;118.431662, 37.432711;118.431592, 37.432756;118.43149, 37.432781;118.425686, 37.432828;118.425433, 37.432829;118.425236, 37.432842;118.424921, 37.432894;118.423863, 37.433142;118.423456, 37.433212;118.421873, 37.433226;118.421756, 37.433302;118.421342, 37.434859;118.420263, 37.437452;118.420179, 37.437553;118.420102, 37.437598;118.419936, 37.437597;118.4171, 37.437694;118.416365, 37.437644;118.415943, 37.437526;118.415791, 37.437469;118.415708, 37.437351;118.415663, 37.437187;118.415654, 37.435833;118.415577, 37.433975;118.415426, 37.433698;118.415281, 37.433593;118.414497, 37.43328;118.414282, 37.433224;118.411961, 37.433215;118.411828, 37.433254;118.411687, 37.43331;118.410419, 37.434265;118.410295, 37.434316;118.407241, 37.435;118.403287, 37.435898;118.399944, 37.436198;118.399269, 37.43638;118.398988, 37.436508;118.398762, 37.436824;118.398627, 37.437076;118.398541, 37.437329;118.398518, 37.437592;118.398668, 37.439519;118.398632, 37.439846;118.397987, 37.441385;118.396964, 37.442551;118.39681, 37.442665;118.396558, 37.442743;118.393844, 37.443065;118.393671, 37.443063;118.393588, 37.442969;118.393108, 37.441877;118.391856, 37.439132;118.390532, 37.43627;118.390251, 37.435685;118.389745, 37.435537;118.389049, 37.435535;118.386624, 37.4357;118.386495, 37.43564;118.38642, 37.435535;118.386177, 37.434293;118.385914, 37.433337;118.385763, 37.433102;118.385639, 37.432973;118.385518, 37.4329;118.385358, 37.43286;118.385094, 37.432827;118.383211, 37.432839;118.376615, 37.432928;118.373388, 37.432996;118.373188, 37.432984;118.372955, 37.432948;118.372628, 37.432798;118.3724, 37.432667;118.372201, 37.43246;118.372097, 37.4322;118.372052, 37.431787;118.372352, 37.429058;118.372608, 37.427128;118.37255, 37.426841;118.372332, 37.426522;118.369783, 37.424736;118.368303, 37.424637;118.364896, 37.424339;118.361012, 37.424108;118.357671, 37.424265;118.357352, 37.424289;118.357034, 37.424358;118.354784, 37.425022;118.354625, 37.425029;118.354417, 37.425024;118.354176, 37.424995;118.353525, 37.424882;118.349984, 37.424781;118.346041, 37.424719;118.345597, 37.424603;118.345346, 37.424487;118.344046, 37.423431;118.342514, 37.421788;118.342377, 37.421742;118.342081, 37.421708;118.339438, 37.421664;118.339224, 37.421695;118.339073, 37.421744;118.337475, 37.422393;118.33503, 37.423294;118.33264, 37.423947;118.329124, 37.424699;118.326849, 37.425175;118.325726, 37.425271;118.323409, 37.425314;118.316601, 37.425546;118.307482, 37.434521;118.306116, 37.435678;118.304271, 37.435883;118.30404, 37.437807;118.303951, 37.437983;118.303768, 37.438172;118.303194, 37.438469;118.302432, 37.438873;118.300992, 37.439363;118.300916, 37.439439;118.300857, 37.439577;118.300639, 37.440968;118.300548, 37.441113;118.30041, 37.441245;118.300256, 37.441352;118.299719, 37.44158;118.299461, 37.441668;118.299303, 37.441668;118.299098, 37.441656;118.297359, 37.441376;118.297139, 37.441364;118.296903, 37.441408;118.294925, 37.442014;118.292633, 37.443215;118.292611, 37.443297;118.292893, 37.445595;118.292864, 37.445682;118.292794, 37.445714;118.292715, 37.445727;118.29145, 37.445539;118.291242, 37.445476;118.291088, 37.445344;118.29098, 37.445187;118.290502, 37.444089;118.290397, 37.443995;118.288303, 37.443506;118.288083, 37.443532;118.284769, 37.44451;118.284613, 37.44458;118.28452, 37.444649;118.284078, 37.445368;118.284037, 37.445581;118.284064, 37.445663;118.285233, 37.446706;118.285251, 37.446768;118.285246, 37.446859;118.285002, 37.448046;118.284851, 37.448131;118.278286, 37.44994;118.278147, 37.450023;118.278078, 37.450087;118.278035, 37.450237;118.27794, 37.451026;118.277743, 37.452478;118.277628, 37.453088;118.277023, 37.454316;118.276189, 37.455908;118.275565, 37.456798;118.275434, 37.456906;118.275317, 37.456983;118.275178, 37.45706;118.27506, 37.457105;118.274863, 37.457139;118.274451, 37.457138;118.272518, 37.457057;118.272399, 37.457059;118.272284, 37.45707;118.272096, 37.457126;118.270592, 37.457718;118.270455, 37.457787;118.270267, 37.458011;118.268585, 37.459962;118.267662, 37.461122;118.266967, 37.461629;118.266084, 37.462287;118.265935, 37.462347;118.265736, 37.462363;118.265131, 37.462326;118.264841, 37.462232;118.264655, 37.462136;118.264426, 37.461934;118.263869, 37.461302;118.26322, 37.460175;118.263058, 37.459877;118.262824, 37.459763;118.261324, 37.459637;118.259766, 37.45996;118.252795, 37.445574;118.248431, 37.43514;118.246407, 37.430942;118.244205, 37.425735;118.243711, 37.423342;118.243638, 37.422089;118.24376, 37.419718;118.244223, 37.41528;118.245809, 37.410413;118.247282, 37.40353;118.247672, 37.401206;118.247595, 37.399765;118.247188, 37.398512;118.246392, 37.397637;118.244384, 37.396267;118.242108, 37.395097;118.238236, 37.393732;118.231548, 37.392658;118.221952, 37.391765",
    //     ],
    //   };
    //   if (boundariesValue.boundaries.length == 0) {
    //     return console.log("未找到经纬度");
    //   }
    //   var count = boundariesValue.boundaries.length;
    //   var EN_JW = "180, 90;"; //东北角
    //   var NW_JW = "-180,  90;"; //西北角
    //   var WS_JW = "-180, -90;"; //西南角
    //   var SE_JW = "180, -90;"; //东南角

    //   //  添加环形遮罩布
    //   var pl1 = new BMap.Polygon(
    //     boundariesValue.boundaries[0] +
    //     SE_JW +
    //     SE_JW +
    //     WS_JW +
    //     NW_JW +
    //     EN_JW +
    //     SE_JW,
    //     {
    //       strokeColor: "none", // 边线颜色
    //       fillColor: "#FFFFFF", // 填充颜色.当参数为空时,圆形奖没有填充效果
    //       fillOpacity: 1, //填充的透明度，取值范围0 - 1。
    //       strokeOpacity: 0.9, //边线的样式，solid或dashed。
    //       StrokeStyle: "solid", //设置多边形边线样式为实线或虚线，取值 solid 或 dashed
    //     }
    //   ); // 建立多边形覆盖物
    //   map.addOverlay(pl1);
    //   map.centerAndZoom(new BMap.Point(118.447968, 37.410984), 12);
    //   //给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
    //   var ply = new BMap.Polygon(boundariesValue.boundaries[0], {
    //     strokeWeight: 4,
    //     fillColor: "",
    //     // StrokeStyle: "dashed", //设置多边形边线样式为实线或虚线，取值 solid 或 dashed
    //   });
    //   // map.addOverlay(ply); 开启将会替换其他的
    //   // map.setViewport(ply.getPath()); //调整视野
    // },

    infoWindowClose(marker) {
      marker.showFlag = false;
    },
    infoWindowOpen(marker) {
      marker.showFlag = true;
    },
    getClickInfo(e) {},
  },
};
</script>

<style lang="scss" scoped>
.map-checkbox {
  border: 3px solid #0196ff;
  display: flex;
  border-radius: 30px;
  padding: 3px;
  position: absolute;
  top: 5%;
  left: 2%;
  z-index: 4;
  opacity: 1;
}

.icoQuan {
  position: absolute;
  top: 6.1%;
  left: 9.4%;
  display: flex;
  width: 240px;
  opacity: 1;

  div {
    flex: 1;

    img {
      position: relative;
      z-index: 5;
    }
  }
}

::v-deep.el-radio-button:first-child .el-radio-button__inner {
  border-radius: 20px;
  padding: 8px 15px 8px 15px;
}

::v-deep .el-radio-button__inner {
  border-radius: 20px;
  padding: 8px 15px 8px 35px;
  border: none;
}

::v-deep.el-radio-button:first-child .el-radio-button__inner {
  border-radius: 20px;
}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 20px;
}

// 状态
.map-data-tip {
  border: 1px solid #0196ff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.35);
  border-radius: 10px;
  width: 130px;
  max-height: 300px;
  height: 100px;
  padding: 10px;
  position: absolute;
  top: 5%;
  right: 0;
  background: rgba(255, 255, 255, 0.7);
  transform: translateX(-50%);
  display: flex;
  color: #434343;
  z-index: 5;
  opacity: 1;
  //  flex-direction: column;
  // justify-content: space-around;
}

.typeOne {
  margin-top: 8px;
  padding-right: 15px;

  span {
    font-size: 15px;
    font-weight: bold;
  }
}

.tip-type {
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    //margin: 5px ;
    padding-right: 10px;
  }

  .gray {
    width: calc(20 / 1920 * 100vw);
    height: calc(5 / 1920 * 100vw);
    background: #676767;
  }

  .red {
    width: calc(20 / 1920 * 100vw);
    height: calc(5 / 1920 * 100vw);
    background: #f14d4d;
  }

  .green {
    width: calc(20 / 1920 * 100vw);
    height: calc(5 / 1920 * 100vw);
    background: #3d7ef2;
  }
}

.Map {
  width: calc(1031 / 1920 * 100vw);
  height: calc(986 / 1080 * 100vh);
  position: relative;
  // 雨情状态
  .rainStatus {
    position: absolute;
    top: calc(20 / 1920 * 100vw);
    left: calc(20 / 1920 * 100vw);
    width: calc(346 / 1920 * 100vw);
    /*height: calc(300 / 1080 * 100vh);*/
    opacity: 0.8;
    border: calc(2 / 1920 * 100vw) solid #0196ff;

    .title {
      margin-top: calc(5 / 1080 * 100vh);
      position: relative;
      height: calc(50 / 1080 * 100vh);

      .line::after {
        content: "";
        width: calc(3 / 1920 * 100vw);
        height: calc(17 / 1080 * 100vh);
        background-color: #3669ab;
        position: absolute;
        left: calc(17 / 1920 * 100vw);
        top: calc(13 / 1080 * 100vh);
      }

      .title-text {
        height: 100%;
        text-indent: calc(34 / 1920 * 100vw);
        line-height: calc(44 / 1080 * 100vh);
        color: #434343;
      }
    }

    .indexLlj {
      padding: 5px 12px;
      margin-bottom: 12px;

      .indexLlj_list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .indexLlj_item {
          display: flex;
          width: 50%;
          align-items: center;
          color: #333333;
          font-weight: 500;

          .img {
            display: block;
            width: 20px;
            height: 24px;
            margin-right: 4px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .a-display {
            display: block;
            margin-left: 5px;
            color: #333;
            font-weight: bold;
            font-size: calc(20 / 1920 * 100vw);
          }

          &:nth-child(3) {
            margin-top: 10px;
          }

          &:nth-child(4) {
            margin-top: 10px;
          }
        }
      }
    }
  }

  ul {
    li {
      position: relative;
      color: #434343;

      .text {
        width: calc(48 / 1920 * 100vw);
        font-size: calc(14 / 1920 * 100vw);
        position: relative;
        left: calc(2 / 1920 * 100vw);

        p {
          position: absolute;

          left: calc(10 / 1920 * 100vw);
          bottom: 0;
        }
      }

      .numberText {
        width: calc(34 / 1920 * 100vw);
        position: relative;
        bottom: calc(1 / 1080 * 100vh);
        // p {
        //   color: #333;
        //   font-weight: bold;
        //   font-size: calc(30 / 1920 * 100vw);
        //   position: relative;
        //   font-size: calc(20 / 1920 * 100vw);
        //   // bottom: 0;
        //   top: 5px;
        // }
      }
    }
  }

  .abul {
    position: absolute;
    top: 35px;
    right: 13%;
  }

  .ul-active {
    padding-bottom: 10px;
  }

  .map {
    width: 100%;
    height: 100%;
  }
}

::v-deep .RainBox {
  width: calc(250 / 1920 * 100vw);
  height: calc(116 / 1080 * 100vh);
  background: rgba(243, 248, 255, 0.5);
  border: calc(3 / 1920 * 100vw) solid #1f78ec;
  border-radius: 8px;

  button {
    margin: calc(10 / 1080 * 100vh) 0;
    margin-left: calc(12 / 1920 * 100vw);
    width: calc(224 / 1920 * 100vw);
    height: calc(30 / 1080 * 100vh);
    background: #1f78ec;
    border-radius: 8px;
    color: #dbebf9;
    font-size: calc(18 / 1920 * 100vw);
    font-weight: bold;
    line-height: calc(20 / 1080 * 100vh) !important;
  }

  .timer {
    margin-top: calc(3 / 1080 * 100vh);
  }

  span:nth-child(1) {
    margin-left: calc(12 / 1080 * 100vh);
    font-size: calc(16 / 1920 * 100vw);
    color: #666666;
  }

  span:nth-child(2) {
    font-size: calc(16 / 1920 * 100vw);
    font-weight: bold;
    color: #333333;
  }
}

::v-deep .rain {
  padding: 3px;
  width: 400px;
  height: 330px;
  background: #217acc;
  box-shadow: 0px 0px 13px 0px rgba(6, 0, 1, 0.27);
  border-radius: 16px;

  .rainBox {
    // margin: 5px;
    width: 400px;
    height: 330px;
    background: #f3f6f8;
    border-radius: 16px;

    .rainBox_title {
      height: 30px;

      .rainBox_title_num {
        width: 150px;
        color: #333;
        font-weight: 400;
      }

      .rainBox_title_text {
        width: 200px;
        color: #217acc;
      }

      .rainBox_title_img {
        // margin-left: 155px;
        width: 15px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .polyin {
      height: 1px;
      background: #666666;
      opacity: 0.1;
      border-radius: 16px;
    }

    // 闸门信息
    .gate {
      height: 65px;

      .gate_title {
        margin-top: 8px;

        p {
          color: #333;
          margin-left: 4px;
        }
      }

      .gate_text {
        .ul_one {
          li {
            width: 50%;
          }
        }

        .ul_two {
          li {
            width: 50%;
          }
        }
      }
    }

    // 水文信息
    .waterMes {
      height: 90px;

      .waterMes_title {
        margin-top: 8px;

        p {
          color: #333;
          margin-left: 4px;
        }
      }

      .waterMes_text {
        margin-top: 5px;
      }

      .ul_one {
        li {
          width: 50%;
        }
      }

      .ul_two {
        li {
          width: 25%;
        }
      }
    }

    // 气象信息
    .mete {
      height: 55px;

      .mete_title {
        margin-top: 8px;

        p {
          color: #333;
          margin-left: 4px;
        }
      }

      .mete_text {
        margin-top: 6px;

        .ul_two {
          li {
            width: 50%;
            // margin-left: 18px;
          }
        }
      }
    }

    .solar {
      height: 60px;

      .solar_title {
        margin-top: 8px;

        p {
          color: #333;
          margin-left: 2px;
        }
      }

      .solar_text {
        margin-top: 8px;

        .ul_two {
          li {
            width: 50%;
          }
        }
      }
    }
  }
}
</style>
